<div xmlns="http://www.w3.org/1999/html">
  <nz-page-header nzBackIcon class="bg-slate-100" *ngIf="isAdd && this.rIti === null" (nzBack)="this.routeBackToItinerariesTable()" [nzGhost]="false">
    <nz-page-header-title class="text-primary"
    >{{ 'itineraries.addEditItinerary.pageTitles.addItinerary' | transloco }}
    </nz-page-header-title
    >
    <nz-page-header-extra *ngIf="isTemplateAdd">
      <div class="text-center flex flex-col justify-center">
        <span class="text-primary font-semibold">{{ 'itineraries.addEditItinerary.madeViaTemplate' | transloco }}</span>
        <span class="text-black-700 text-sm font-semibold">{{ singleItinerary?.title ? singleItinerary.title : ''  }}</span>
      </div>
    </nz-page-header-extra>
  </nz-page-header>
  <nz-page-header nzBackIcon class="bg-slate-100" (nzBack)="this.routeBackToItinerariesTable()" *ngIf="this.isAdd && this.rIti !== null" [nzGhost]="false">
    <nz-page-header-title class="text-primary"
    >{{ 'itineraries.addEditItinerary.pageTitles.updateItinerary' | transloco }}
    </nz-page-header-title
    >
  </nz-page-header>
  <nz-page-header nzBackIcon class="bg-slate-100" (nzBack)="this.routeBackToItinerariesTable()" *ngIf="!isAdd" [nzGhost]="false">
    <nz-page-header-title *ngIf="!isAdd" class="text-primary"
    >{{ (mode === 'template' ? 'itineraries.addEditItinerary.pageTitles.editTemplate' : 'itineraries.addEditItinerary.pageTitles.editItinerary') | transloco }}
    </nz-page-header-title
    >
    <nz-page-header-extra *ngIf="this.singleItinerary?.isCreatedFromTemplate">
      <div class="text-center flex flex-col justify-center">
        <span class="text-primary font-semibold">{{ 'itineraries.addEditItinerary.madeViaTemplate' | transloco }}</span>
        <span class="text-black-700 text-sm font-semibold">{{ singleItinerary?.templateTitle ? singleItinerary.templateTitle : '' }}</span>
      </div>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="drop-shadow bottom-2 right-2 fixed z-50" *ngIf="!isAdd" id="update-button">
  <div class="py-5 px-10 bg-base-200 text-center">
    <div class="flex">
      <button
        class="mb-3 mr-2"
        nz-button
        nzType="primary"
        (click)="updateItineraryContent(false)"
        [disabled]="btnLoading || this.singleItinerary?.lock === null || this.determineStatusLogic() || this.cardLoading"
        [nzLoading]="btnLoading">
        {{ 'itineraries.addEditItinerary.form.actions.update' | transloco }}
      </button>
      <a
        class="flex justify-center items-center"
        *appHasAnyPrivilege="'ITINERARY.PREVIEW'"
        nz-button
        nzType="primary"
        [disabled]="this.cardLoading"
        (click)="this.updateItineraryContent(); this.onClickNavigateToPreview(this.singleItinerary)"
        target="_blank">
        <span nz-icon nzType="eye" nzTheme="outline"></span>
      </a>
      <button
        *ngIf="mode !== 'template'"
        class="ml-2"
        nz-button
        nzType="default"
        nz-dropdown
        [nzDropdownMenu]="menu"
        [nzDisabled]="this.cardLoading"
        [disabled]="this.cardLoading"
        [nzLoading]="btnLoading">
        <div class='flex flex-row justify-center items-center gap-3'>
          <span>{{ 'itineraries.addEditItinerary.shareMenu.share' | transloco }}</span>
          <span><lucide-icon class="share-icons" name="corner-up-right"></lucide-icon></span>
        </div>
      </button>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item nz-button (click)="this.generateSimpleWord()">
            <div class="flex flex-row justify-center items-center gap-3">
              <span class="text-[#7827db]">{{ 'itineraries.addEditItinerary.shareMenu.downloadWord' | transloco }}</span>
              <span><lucide-icon class="share-dropdown-icons text-[#7827db]"
                                 name="download"></lucide-icon></span>
            </div>
          </li>
          <li nz-menu-item *ngIf="this.singleItinerary?.tour.type !=='B2C' && this.isNotExpiredRealTime" (click)="this.singleItinerary?.isSharingEnabled ? this.generateLink() : ''">
            <div class="flex flex-row justify-center items-center gap-3">
              <span [ngClass]="!this.singleItinerary?.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'">
                {{ 'itineraries.addEditItinerary.shareMenu.generateEditableLink' | transloco }}
              </span>
              <span>
                <lucide-icon [ngClass]="!this.singleItinerary?.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'"
                             class="share-dropdown-icons "
                             name="corner-up-right"></lucide-icon>
              </span>
            </div>
          </li>
          <li nz-menu-item *ngIf="this.singleItinerary?.tour.type !=='B2C' && !this.isNotExpiredRealTime" (click)="this.singleItinerary?.isSharingEnabled ? this.copyGeneratedLink(): '' ">
            <div class="flex flex-row justify-center items-center gap-3">
              <span [ngClass]="!this.singleItinerary?.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'">{{ 'itineraries.addEditItinerary.shareMenu.copyEditableLink' | transloco }}</span>
              <span> <lucide-icon
                [ngClass]="!this.singleItinerary?.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'"
                class="share-dropdown-icons" name="refresh-cw"></lucide-icon></span>
            </div>
          </li>
          <li nz-menu-item *ngIf="this.singleItinerary?.tour.type ==='B2C'" (click)="this.singleItinerary?.isSharingEnabled ? copyLink(this.singleItinerary) : ''">
            <div class="flex flex-row justify-center items-center gap-3">
              <span [ngClass]="!this.singleItinerary.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'"  class="">{{ 'itineraries.addEditItinerary.shareMenu.copyShareLink' | transloco }}</span>
              <span><lucide-icon
                [ngClass]="!this.singleItinerary.isSharingEnabled ? 'text-[#FF0000] hover:cursor-not-allowed' : 'text-[#7827db]'"
                class="share-dropdown-icons "
                name="corner-up-right"></lucide-icon></span>
            </div>
          </li>
          <li nz-menu-item *ngIf="this.singleItinerary?.tour.type ==='B2C'" (click)="sendItineraryShowModal(this.singleItinerary._id,
                    this.singleItinerary.creator,
                    this.singleItinerary.full_name,
                    this.singleItinerary.tour.customer.email,
                    this.singleItinerary.tour.themeType)">
            <div class="flex flex-row justify-center items-center gap-3">
              <span class="text-[#7827db]">{{ 'itineraries.addEditItinerary.shareMenu.sendItinerary' | transloco }}</span>
              <span><lucide-icon class="share-dropdown-icons text-[#7827db]"
                                 name="send-horizontal"></lucide-icon></span>
            </div>
          </li>
          <li nz-menu-item *ngIf="this.singleItinerary?.tour.type ==='B2C'" (click)="this.exportContent(this.singleItinerary._id)">
            <div class="flex flex-row justify-center items-center gap-3">
              <span class="text-[#7827db]">{{ 'itineraries.addEditItinerary.shareMenu.export' | transloco }}</span>
              <span><lucide-icon class="share-dropdown-icons text-[#7827db]"
                                 name="download"></lucide-icon></span>
            </div>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
    <p class="text-sm mr-2" *ngIf="updatedTime">
      {{ 'itineraries.addEditItinerary.summary.lastUpdated' | transloco:{ time: getTimeAgo(updatedTime) } }}
    </p>
  </div>
</div>
<nz-spin [nzSpinning]="cardLoading">
  <nz-card class="my-8" *ngIf="isAdd">
    <div><h5>{{ 'itineraries.addEditItinerary.form.tourInformation' | transloco }}</h5></div>
    <nz-divider></nz-divider>

    <form nz-form [formGroup]="tourForm" id="tour-information-section" nzLayout="vertical">

      <!-- Row 1: Type | Agent (B2B) | Contact (B2B) -->
      <div class="grid md:grid-cols-3 gap-10 mb-6">
        <div>
          <!-- Type -->
          <div>
            <nz-form-item>
              <nz-form-label
                nzRequired
                nzFor="type"
              >{{ 'itineraries.addEditItinerary.form.fields.type' | transloco }}</nz-form-label>
              <nz-form-control [nzErrorTip]="typeCheck">
                <nz-select
                  [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectType' | transloco"
                  formControlName="type"
                  nzShowSearch
                  [(ngModel)]="recentlyItinerary.type"
                >
                  <nz-option
                    *ngFor="let c of SETTINGS.ITINERARY_TYPES"
                    [nzValue]="c.value"
                    [nzLabel]="c.label">
                  </nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #typeCheck>
                <span *ngIf="formErrors.type.required">{{ 'itineraries.addEditItinerary.form.errors.typeRequired' | transloco }}</span>
              </ng-template>
            </nz-form-item>
          </div>

          <!-- Agent (only for B2B) -->
          <div *ngIf="tourForm.get('type').value === 'B2B'">
            <nz-form-item>
              <nz-form-label
                nzFor="agent"
              >{{ 'itineraries.addEditItinerary.form.fields.agent' | transloco }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectAgent' | transloco"
                  formControlName="agent"
                  nzShowSearch
                >
                  <nz-option
                    *ngFor="let c of activeAgents"
                    [nzValue]="c._id"
                    [nzLabel]="c.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Contact (only for B2B) -->
          <div *ngIf="tourForm.get('type').value === 'B2B'">
            <nz-form-item>
              <nz-form-label
                nzFor="selectedContact"
              >{{ 'itineraries.addEditItinerary.form.fields.contact' | transloco }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectContact' | transloco"
                  formControlName="selectedContact"
                  nzShowSearch
                  [(ngModel)]="recentlyItinerary.selectedContact"
                >
                  <nz-option
                    *ngFor="let c of agentContacts"
                    [nzValue]="c._id"
                    [nzLabel]="c.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Customer -->
          <div class="md:col-span-2 xl:col-auto">
            <nz-form-item>
              <nz-form-label
                [nzRequired]="tourForm.get('type').value === 'B2C'"
                nzFor="customer"
              >{{ 'itineraries.addEditItinerary.form.fields.customer' | transloco }}</nz-form-label>
              <nz-form-control [nzErrorTip]="customerCheck">
                <div class="flex flex-row gap-2">
                  <nz-select
                    class="flex-1"
                    [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectCustomer' | transloco"
                    formControlName="customer"
                    nzShowSearch
                    nzAllowClear
                    [(ngModel)]="recentlyItinerary.customer"
                  >
                    <nz-option
                      *ngFor="let c of sortOrderByCustomerName(activeCustomers)"
                      [nzValue]="c._id"
                      [nzLabel]="c.first_name + ' ' + c.last_name">
                    </nz-option>
                  </nz-select>
                  <button *appHasAnyPrivilege="'ITINERARY.ADD.CUSTOMER'"
                          type="button"
                          nz-button nzType="primary"
                          (click)="onClickPopUp()" class="flex items-center justify-center">
                    <lucide-icon name="user-plus" class="icon-size"></lucide-icon>
                  </button>
                </div>
              </nz-form-control>
              <ng-template #customerCheck>
                <span *ngIf="formErrors.customer.required">{{ 'itineraries.addEditItinerary.form.errors.customerRequired' | transloco }}</span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
        <!-- Tour Dates & Pax -->
        <div>
          <nz-form-item>
            <nz-form-control>
              <label
                nz-checkbox
                formControlName="isDatesOptional"
              >{{ 'itineraries.addEditItinerary.form.fields.datesNotSpecified' | transloco }}</label>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item *ngIf="!this.tourForm.get('isDatesOptional')?.value">
            <nz-form-label
              nzRequired
              nzFor="tourDates"
            >{{ 'itineraries.addEditItinerary.form.fields.tourDates' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="tourDate">
              <nz-range-picker
                (keydown)="$event.preventDefault()"
                formControlName="tourDates"
                class="w-full">
              </nz-range-picker>
            </nz-form-control>
            <ng-template #tourDate>
              <span *ngIf="formErrors.noOfDays.required">{{ 'itineraries.addEditItinerary.form.errors.datesRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>

          <nz-form-item *ngIf="!this.tourForm.get('isDatesOptional')?.value">
            <nz-form-label
              nzRequired
              nzFor="noOfDays"
            >{{ 'itineraries.addEditItinerary.form.fields.numberOfDays' | transloco }}</nz-form-label>
            <nz-form-control>
              <p class="font-medium">
                {{ tourForm.getRawValue().noOfDays || 0 }} (
                {{
                  tourForm.getRawValue().noOfDays
                    ? (tourForm.getRawValue().noOfDays - 1) + (' ' + ('itineraries.addEditItinerary.form.fields.nights' | transloco))
                    : ('0 ' + ('itineraries.addEditItinerary.form.fields.nights' | transloco))
                }}
                )
              </p>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item *ngIf="this.tourForm.get('isDatesOptional')?.value">
            <nz-form-label
              nzRequired
              nzFor="noOfDays"
            >{{ 'itineraries.addEditItinerary.form.fields.numberOfDays' | transloco }}</nz-form-label>
            <nz-form-control>
              <nz-input-number
                class="pax-input"
                formControlName="noOfDays"
                [nzMin]="1"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.enter' | transloco"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label nzFor="season">
              <span class="flex items-center justify-center gap-2">
                {{ 'itineraries.addEditItinerary.form.fields.season' | transloco }}
                <span
                  nz-tooltip
                  [nzTooltipTitle]="'itineraries.addEditItinerary.form.tooltips.predefineSeasons' | transloco">
                  <span nz-icon nzType="info-circle" nzTheme="fill" class="text-gray-400 cursor-pointer mb-2"></span>
                </span>
              </span>
            </nz-form-label>
            <nz-form-control>
              <nz-select
                class="w-full"
                formControlName="season"
                nzAllowClear
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectSeason' | transloco">
                <nz-option
                  *ngFor="let season of seasonCategory"
                  [nzValue]="season._id"
                  [nzLabel]="season.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="pax"
            >{{ 'itineraries.addEditItinerary.form.fields.numberOfPax' | transloco }}</nz-form-label>
            <nz-form-control
              formGroupName="pax"
              [nzErrorTip]="'itineraries.addEditItinerary.form.errors.paxRequired' | transloco"
            >
              <div class="flex gap-4">
                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="adults"
                    [nzMin]="1"
                    [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.adults' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input"
                  ></nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">
                    {{ 'itineraries.addEditItinerary.form.fields.adult' | transloco }}
                  </nz-tag>
                </div>
                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="children"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.children' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input"
                  ></nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">{{ 'itineraries.addEditItinerary.form.fields.children' | transloco }}</nz-tag>
                </div>

                <div class="flex flex-col gap-2">
                  <nz-input-number
                    formControlName="infants"
                    [nzMin]="0"
                    [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.infants' | transloco"
                    class="xl:w-full lg:w-3/5 pax-input"
                  ></nz-input-number>
                  <nz-tag class="m-0" nzColor="purple">{{ 'itineraries.addEditItinerary.form.fields.infant' | transloco }}</nz-tag>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Currency & Language -->
        <div>
          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="currency"
            >{{ 'itineraries.addEditItinerary.form.fields.primaryCurrency' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="currencyCheck"
                             [nzExtra]="'itineraries.addEditItinerary.form.extras.primaryCurrency' | transloco">
              <nz-select
                formControlName="currency"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectCurrency' | transloco"
                nzShowSearch
                [(ngModel)]="recentlyItinerary.currency"
              >
                <nz-option
                  *ngFor="let cur of sortOrderCurrency(currencies)"
                  [nzValue]="cur.cc"
                  [nzLabel]="cur.cc">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #currencyCheck>
              <span *ngIf="formErrors.currency.required">{{ 'itineraries.addEditItinerary.form.errors.currencyRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label
              nzFor="secondaryCurrency"
            >{{ 'itineraries.addEditItinerary.form.fields.secondaryCurrency' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="secondaryCurrencyCheck"
                             [nzExtra]="'itineraries.addEditItinerary.form.extras.secondaryCurrency' | transloco">
              <nz-select
                formControlName="secondaryCurrency"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectSecondaryCurrency' | transloco"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let cur of sortOrderCurrency(currencies)"
                  [nzValue]="cur.cc"
                  [nzLabel]="cur.cc">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #secondaryCurrencyCheck>
              <span *ngIf="formErrors.secondaryCurrency.required">{{ 'itineraries.addEditItinerary.form.errors.secondaryCurrencyRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>

          <nz-form-item
            *ngIf="tourForm.get('secondaryCurrency').value"
          >
            <nz-form-label
              nzRequired
              nzFor="exchangeRate"
            >{{ 'itineraries.addEditItinerary.form.fields.exchangeRate' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="exchangeRateCheck" [nzExtra]="'itineraries.addEditItinerary.form.extras.exchangeRate' | transloco">
              <nz-input-number
                [nzFormatter]="formatter"
                [nzParser]="parser"
                [nzPrecision]="2"
                [nzStep]="0.01"
                class="w-full"
                formControlName="exchangeRate"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.enterRate' | transloco"
              ></nz-input-number>
            </nz-form-control>
            <ng-template #exchangeRateCheck>
              <span *ngIf="formErrors.exchangeRate.required">{{ 'itineraries.addEditItinerary.form.errors.exchangeRateRequired' | transloco }}</span>
              <span *ngIf="formErrors.exchangeRate.min">{{ 'itineraries.addEditItinerary.form.errors.exchangeRateMin' | transloco }}</span>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label
              nzRequired
              nzFor="language"
            >{{ 'itineraries.addEditItinerary.form.fields.language' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="languageCheck">
              <nz-select
                [nzDisabled]="this.isTemplateAdd ? true : isAdd && rIti !== null"
                formControlName="language"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectLanguage' | transloco"
                [(ngModel)]="recentlyItinerary.language"
              >
                <nz-option
                  *ngFor="let l of orderByName(getSelectedLanguagesObjectArray())"
                  [nzValue]="l.code"
                  [nzLabel]="l.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #languageCheck>
              <span *ngIf="formErrors.language.required">{{ 'itineraries.addEditItinerary.form.errors.languageRequired' | transloco }}</span>
            </ng-template>
          </nz-form-item>
        </div>
      </div>
      <nz-divider></nz-divider>
      <div><h5>{{ 'itineraries.addEditItinerary.form.categoryAndTags' | transloco }}</h5></div>
      <div class="grid md:grid-cols-2 gap-10 my-6">
          <div>
            <nz-form-item>
              <nz-form-label
                nzFor="category"
              >{{ 'itineraries.addEditItinerary.form.fields.category' | transloco }}</nz-form-label>
              <nz-form-control>
                <nz-select
                  [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectCategory' | transloco"
                  formControlName="category"
                  nzShowSearch
                >
                  <nz-option
                    *ngFor="let c of this.activeCategories"
                    [nzValue]="c._id"
                    [nzLabel]="c.name">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        <div>
          <nz-form-item>
            <nz-form-label
              nzFor="tags"
            >{{ 'itineraries.addEditItinerary.form.fields.tags' | transloco }}</nz-form-label>
            <nz-form-control>
              <nz-select
                [nzShowArrow]="true"
                nzMode="tags"
                [nzPlaceHolder]="'itineraries.addEditItinerary.form.placeholders.selectTags' | transloco"
                formControlName="tags"
                nzAllowClear
              >
                <nz-option
                  *ngFor="let c of this.activeTags"
                  [nzValue]="c._id"
                  [nzLabel]="c.name">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <nz-divider></nz-divider>
      <!-- Actions -->
      <div class="flex justify-end mt-6">
        <button id="next-button"
          *ngIf="isAdd && rIti === null"
          nz-button nzType="primary"
          (click)="!isTemplateAdd ? createItinerary() : createItineraryFromTemplate()"
          [disabled]="tourForm.invalid"
        >{{ 'itineraries.addEditItinerary.form.actions.next' | transloco }}</button>
        <button
          *ngIf="isAdd && rIti !== null"
          nz-button nzType="primary"
          (click)="updateItineraryTourInformation()"
          [disabled]="tourForm.invalid"
        >{{ 'itineraries.addEditItinerary.form.actions.update' | transloco }}</button>
      </div>
    </form>
  </nz-card>
</nz-spin>
<div class="my-8" *ngIf="!isAdd">
  <nz-spin [nzSpinning]="cardLoading">
    <ng-container *ngIf="this.singleItinerary?.readOnly">
      <nz-alert *ngIf="this.singleItinerary?.lockedByAnotherTab; else otherUserAlert"
                nzType="warning"
                nzShowIcon
                [nzMessage]="'itineraries.addEditItinerary.inUseAnotherTabAlert' | transloco">
      </nz-alert>
      <ng-template #otherUserAlert>
        <nz-alert nzType="error"
                  nzShowIcon
                  [nzMessage]="'itineraries.addEditItinerary.readOnlyAlert' | transloco:{ user: this.singleItinerary.lockedBy }">
        </nz-alert>
      </ng-template>
    </ng-container>
    <nz-card class="mt-3">
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngIf="this.singleItinerary?.tour?.customer">
          <h5 class="mb-3 flex flex-row items-center gap-2 whitespace-nowrap">
            <span nz-icon nzType="contacts" nzTheme="fill"></span> {{ 'itineraries.addEditItinerary.summary.customerInformation' | transloco }}
          </h5>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.summary.name' | transloco }}</span>:
            {{ singleItinerary?.full_name || ('itineraries.common.emptyValue' | transloco) }}
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.summary.email' | transloco }}</span>:
            {{ singleItinerary?.tour?.customer?.email || ('itineraries.common.emptyValue' | transloco) }}
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.summary.contact' | transloco }}</span>:
            {{singleItinerary?.tour?.customer?.dialCode || ""}} {{singleItinerary?.tour?.customer?.contact || ('itineraries.common.emptyValue' | transloco) }}
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.summary.country' | transloco }}</span>:
            {{ singleItinerary?.tour?.customer?.country.name || ('itineraries.common.emptyValue' | transloco) }}
          </p>
        </div>
        <div>
          <h5 class="mb-3 flex flex-row items-center gap-2 whitespace-nowrap">
            <span nz-icon nzType="compass" nzTheme="fill"></span> {{ 'itineraries.addEditItinerary.summary.tourInformation' | transloco }}
          </h5>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.numberOfDays' | transloco }}</span>:
            {{ singleItinerary?.tour.noOfDays }} ( {{
              singleItinerary?.tour.noOfDays !== 1
                ? (singleItinerary?.tour.noOfDays - 1) + ' ' + ('itineraries.addEditItinerary.form.fields.nights' | transloco)
                : '0 ' + ('itineraries.addEditItinerary.form.fields.nights' | transloco)
            }} )
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.numberOfPax' | transloco }}</span>:
            <nz-tag [nzColor]="'purple'"
            >{{ singleItinerary?.tour.pax.adults }} {{ 'itineraries.addEditItinerary.form.placeholders.adults' | transloco }}
            </nz-tag
            >
            <nz-tag [nzColor]="'purple'"
            >{{ singleItinerary?.tour.pax.children }} {{ 'itineraries.addEditItinerary.form.placeholders.children' | transloco }}
            </nz-tag
            >
            <nz-tag [nzColor]="'purple'"
            >{{ singleItinerary?.tour.pax.infants }} {{ 'itineraries.addEditItinerary.form.placeholders.infants' | transloco }}
            </nz-tag
            >
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.type' | transloco }}</span>:
            {{ singleItinerary?.tour.type }}
          </p>
          <p class="mb-2" *ngIf="singleItinerary?.tour?.season">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.summary.season' | transloco }}</span>:
            {{ singleItinerary?.tour?.season?.name }} ({{ 'from' | transloco }} {{ singleItinerary?.tour?.season?.startMonth }} {{ 'to' | transloco }} {{ singleItinerary?.tour?.season?.endMonth }})
          </p>
          <p class="mb-2" *ngIf="singleItinerary?.tour?.category">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.category' | transloco }}</span>:
            {{ singleItinerary?.tour?.category?.name }}
          </p>
          <p class="mb-2" *ngIf="this.singleItinerary?.tour?.tags?.length !== 0">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.tags' | transloco }}</span>:
            <nz-tag class="mb-1" *ngFor="let tag of this.singleItinerary?.tour?.tags" [nzColor]="'purple'"
            >{{ tag}}
            </nz-tag>
          </p>
        </div>
        <div>
          <h5 class="mb-3 flex flex-row items-center gap-2 whitespace-nowrap">
            <span nz-icon nzType="compass" nzTheme="fill"></span> {{ 'itineraries.addEditItinerary.summary.tourOptions' | transloco }}
          </h5>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.primaryCurrency' | transloco }}</span>:
            <nz-tag style="text-transform: uppercase" [nzColor]="'green'">{{
                singleItinerary?.tour.currency
              }}
            </nz-tag>
          </p>
          <p class="mb-2" *ngIf="this.singleItinerary?.tour?.secondaryCurrency">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.secondaryCurrency' | transloco }}</span>:
            <nz-tag style="text-transform: uppercase" [nzColor]="'green'">{{
                singleItinerary?.tour.secondaryCurrency
              }}
            </nz-tag>
          </p>
          <p class="mb-2" *ngIf="this.singleItinerary?.tour?.secondaryCurrency">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.exchangeRate' | transloco }}</span>: {{
                singleItinerary?.tour.exchangeRate
              }}
          </p>
          <p class="mb-2">
            <span class="font-medium">{{ 'itineraries.addEditItinerary.form.fields.language' | transloco }}</span>:
            <span>{{
                findLanguageByCode(singleItinerary?.tour?.language)
              }}</span>
          </p>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="mb-3 mr-2"
          nz-button
          nzType="primary"
          (click)="this.onClickNavigateEdit()"
          [disabled]="btnLoading || this.singleItinerary?.lock === null || this.determineStatusLogic()"
          [nzLoading]="btnLoading">
          {{ 'itineraries.addEditItinerary.summary.editTourInformation' | transloco }}
        </button>
      </div>
    </nz-card>
  </nz-spin>
  <nz-spin [nzSpinning]="cardLoading">
    <div class="grid lg:grid-cols-12 md-grid-cols-6 gap-10">
      <div class="col-span-6">
        <nz-card class="mt-8">
          <h5>{{ 'itineraries.addEditItinerary.themeOptions.title' | transloco }}</h5>
          <nz-divider></nz-divider>
          <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
            <div class="md:col-span-2 xl:col-auto">
              <nz-form-item class="flex">
<!--                <nz-form-label-->
<!--                  class="w-1/4 md:w-fit xl:w-1/3"-->
<!--                  nzFor="type">-->
<!--                  Type-->
<!--                </nz-form-label>-->
                <nz-form-control>
                  <nz-spin nzSpinning="false">
                    <nz-select
                      [nzPlaceHolder]="'itineraries.addEditItinerary.themeOptions.selectThemeType' | transloco"
                      [(ngModel)]="this.themeType"
                      (ngModelChange)="this.onChangeThemeType($event)"
                      [ngModelOptions]="{standalone: true}"
                      [nzDisabled]="this.singleItinerary?.readOnly || this.determineStatusLogic()"
                      [nzOptions]="SETTINGS.ITINERARY_THEME_TYPES">
                    </nz-select>
                  </nz-spin>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div>

            </div>
          </div>
        </nz-card>
      </div>
      <div class="col-span-6">
        <nz-card class="mt-8" id="itinerary-title">
          <h5>{{ mode === 'template' ? ('itineraries.addEditItinerary.itineraryTitle.templateTitle' | transloco) : ('itineraries.addEditItinerary.itineraryTitle.title' | transloco) }}</h5>
          <nz-divider></nz-divider>
          <div class="grid grid-cols-1 gap-6">
            <form nz-form [formGroup]="this.titleForm">
              <nz-form-item class="flex">
                <nz-form-control>
                  <input
                    type="text"
                    nz-input
                    class="w-full"
                    formControlName="title"
                    [placeholder]="mode === 'template' ? ('itineraries.addEditItinerary.itineraryTitle.enterTemplateTitle' | transloco) : ('itineraries.addEditItinerary.itineraryTitle.enterTitle' | transloco)" />
                </nz-form-control>
              </nz-form-item>
            </form>
          </div>
        </nz-card>
      </div>
      <div class="lg:col-span-7 md-col-span-12">
        <nz-card>
          <form nz-form>
            <div [formGroup]="itineraryForm">
              <div class="flex justify-between">
                <h5>{{ 'itineraries.addEditItinerary.itinerarySection.title' | transloco }}</h5>
                <button nz-button *ngIf="this.singleItinerary?.days.length !== 0 && this.singleItinerary?.lock !== null && !determineStatusLogic()"
                        (click)="this.onClickMoveDeleteModal()"
                        type="button"
                        nzSize="small"
                        nzType="default">
                  {{ 'itineraries.addEditItinerary.itinerarySection.manageDays' | transloco }}
                </button>
              </div>
              <nz-divider></nz-divider>
              <nz-tabset id="plan-days-section"
                [nzTabBarGutter]="1"
                (nzSelectedIndexChange)="getTabIndex($event)"
                (nzSelectChange)="onTabChange($event)">
                <nz-tab
                  *ngFor="let day of this.singleItinerary?.days; let i = index"
                  [nzTitle]="('itineraries.addEditItinerary.itinerarySection.dayTab' | transloco:{ day: (i + 1 | number:'2.0-0') })">
                  <div>
                    <div class="grid md:grid-cols-12 gap-6">
                      <div class="md:col-span-12 lg:col-span-12">
                        <div>
                          <div class="mb-5 flex justify-between items-center">
                            <div>
                              <h4 class="hidden">
                                {{ 'itineraries.addEditItinerary.itinerarySection.dayOverview' | transloco }}
                              </h4>
                              <p class="text-xl">{{ !this.singleItinerary.tour.isDatesOptional ?  (day?.date | date) : "" }}</p>
                            </div>
                            <div class="flex items-center gap-5">
                              <div class="flex flex-row items-center gap-2">
                                <nz-icon nz-tooltip
                                          nzTooltipPlacement = 'left'
                                          [nzTooltipArrowPointAtCenter]="true"
                                          [nzTooltipTitle]="'itineraries.addEditItinerary.itinerarySection.leisureDayTooltip' | transloco"
                                          [nzTooltipOverlayStyle]="{
                                                'max-width': '400px',
                                                'min-width': '300px',
                                                'white-space': 'normal',
                                                'line-height': '1.5'
                                              }"
                                          nz-icon nzType="info-circle" nzTheme="outline">
                                </nz-icon>
                                <p class="text-xl">{{ 'itineraries.addEditItinerary.itinerarySection.leisureDay' | transloco }}</p>
                                <nz-switch
                                  [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                  [(ngModel)]="day.isLeisureDay"
                                  [ngModelOptions]="{standalone: true}"
                                  (ngModelChange)="this.onChangeSwitch($event, i)"
                                ></nz-switch>
                              </div>
                              <button *ngIf="!determineStatusLogic()"  class="flex items-center"
                                       nz-button
                                       nzType="default"
                                       nz-dropdown
                                       [nzDropdownMenu]="menu"
                                       [nzTrigger]="'hover'"
                                       [nzDisabled]="singleItinerary?.lock === null"
                                       [disabled]="singleItinerary?.lock === null">
                                {{ 'itineraries.addEditItinerary.itinerarySection.add' | transloco }}
                                <span nz-icon nzType="down"></span>
                              </button>
                              <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu>
                                  <li nz-menu-item
                                      [nzDisabled]="day.isLeisureDay || (departureBoxChecked && i === this.singleItinerary?.days.length - 1)"
                                      (click)="addEditDestinationContent(this.singleItinerary,  i, SETTINGS.ITINERARY_CONTENT_MODE.NEW, null, null, i, '')">
                                      {{ 'itineraries.actions.destination' | transloco }}
                                  </li>
                                  <li nz-menu-item
                                      [nzDisabled]="day.isLeisureDay"
                                      (click)="addEditExperiencesContent(this.singleItinerary,  i, SETTINGS.ITINERARY_CONTENT_MODE.NEW, null, '', null, '', day?.destination?.country, 0, 0)">
                                    {{ 'itineraries.actions.experiences' | transloco }}
                                  </li>
                                  <li nz-menu-item
                                      [nzDisabled]="day.isLeisureDay || (this.accommodations.length === 1 || (departureBoxChecked && i === this.singleItinerary?.days.length - 1))"
                                      (click)="addEditAccommodationsContent(this.singleItinerary, SETTINGS.ITINERARY_CONTENT_MODE.NEW, null, day?.destination?.country)">
                                    {{ 'itineraries.addEditItinerary.itinerarySection.accommodationHotels' | transloco }}
                                  </li>
                                  <li nz-menu-item
                                      (click)="addEditTransportContent(this.singleItinerary, SETTINGS.ITINERARY_CONTENT_MODE.NEW, null,  this.tabIndex, day?.destination?.country)">
                                    {{ 'itineraries.actions.transport' | transloco }}
                                  </li>
                                </ul>
                              </nz-dropdown-menu>
                            </div>
                          </div>
                          <div class="flex justify-end" *ngIf="i === this.singleItinerary?.days.length - 1">
                            <label
                              class="text-sm"
                              nz-checkbox
                              [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="departureBoxChecked"
                              [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                              (ngModelChange)="onChangeDepartureCheckedBox($event)"
                            >{{ 'itineraries.addEditItinerary.itinerarySection.setDayAsDeparture' | transloco }}</label>
                          </div>
                        </div>
                        <textarea class="hidden"
                                  nz-input
                                  [placeholder]="'itineraries.addEditItinerary.itinerarySection.addOverviewForDay' | transloco"
                                  [(ngModel)]="overviewDescription"
                                  [value]="overviewDescription"
                                  (ngModelChange)="addOverviewDescriptionOnChange($event,i)"
                                  [ngModelOptions]="{standalone: true}"
                                  rows="12"></textarea>
                      </div>
                      <div *ngIf=" !day.isLeisureDay && (!departureBoxChecked || i !== this.singleItinerary?.days.length - 1)"
                           class="md:col-span-12 lg:col-span-12">
                      <div>
                        <div class="mb-2 flex flex-row items-center justify-between">
                          <div>
                            <h5 class="font-semibold">{{ 'itineraries.actions.destination' | transloco }}</h5>
                          </div>
                          <ng-container *ngIf="i !== 0">
                            <ng-container *ngIf="day?.destination && (this.singleItinerary?.days[i - 1]?.destination?._id === day?.destination?._id)">
                              <div class="flex flex-row items-center gap-2">
                              <nz-icon nz-tooltip
                                       nzTooltipPlacement = 'left'
                                       [nzTooltipArrowPointAtCenter]="true"
                                       [nzTooltipTitle]="'itineraries.addEditItinerary.itinerarySection.mergePreviousDayTooltip' | transloco"
                                       [nzTooltipOverlayStyle]="{
                                              'max-width': '400px',
                                              'min-width': '300px',
                                              'white-space': 'normal',
                                              'line-height': '1.5'
                                            }"
                                       nz-icon nzType="info-circle" nzTheme="outline">
                              </nz-icon>
                              <p class="text-xl">{{ 'itineraries.addEditItinerary.itinerarySection.mergeWithPreviousDay' | transloco }}</p>
                              <nz-switch
                                [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                [(ngModel)]="day.isMerged"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="this.onChangeMergeToggle($event, i)"
                              ></nz-switch>
                            </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>
                      <div *ngIf="this.singleItinerary.days[i]?.destination; else noDestinationBlock"
                           class=" group bg-destination w-auto h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
                        <div class="ps-4 flex items-center">
                          <span class="text-lg sm:text-2xl" nz-icon nzType="flag" nzTheme="fill"></span>
                          <h5 (click)="viewDestinationContent(this.singleItinerary, this.singleItinerary.days[i])"
                              class="px-3 cursor-pointer sm:text-xl text-base">
                            {{ displayTitle(this.singleItinerary.days[i]?.destination.titles, this.singleItinerary.tour.language) }}
                          </h5>
                        </div>
                        <div  class="invisible group-hover:visible pe-4 flex items-center">
                          <span class=" text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                nzType="eye"
                                nzTheme="outline"
                                (click)="viewDestinationContent(this.singleItinerary, this.singleItinerary.days[i])">
                          </span>
                          <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()" class="text-[#7C37DA] text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                nzType="edit"
                                  nzTheme="outline"
                                  (click)="addEditDestinationContent(this.singleItinerary,  this.findDaysIndex(this.singleItinerary.days, this.singleItinerary.days[i].destination._id),
                                  SETTINGS.ITINERARY_CONTENT_MODE.EDIT, this.singleItinerary.days[i].destination.entryType === 'google' ? this.singleItinerary.days[i].destination.apiId : this.singleItinerary.days[i].destination._id ,
                                  this.singleItinerary.days[i].featuredDestination,i, this.singleItinerary.days[i].destination.entryType)"
                            ></span>
                           <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()" nz-popconfirm
                                 [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteDestinationConfirm' | transloco"
                                 nzPopconfirmPlacement="top"
                                 [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                 [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                 (nzOnConfirm)="onConfirmDeleteDestination( i, { days: this.singleItinerary.days})"
                                 (nzOnCancel)="cancel()"
                                 class="text-[#F96074] cursor-pointer" >
                            <lucide-icon name="trash-2" class="icon-size-2"></lucide-icon>
                          </span>
                        </div>
                      </div>
                      <ng-template #noDestinationBlock>
                        <p>{{ 'itineraries.addEditItinerary.itinerarySection.noDestinationForDay' | transloco }}</p>
                      </ng-template>
                    </div>
                      <div *ngIf="!day.isLeisureDay" class="md:col-span-12 lg:col-span-12">
                        <div>
                          <div class="mb-2 flex items-center gap-4">
                            <div>
                              <h5 class="font-semibold">{{ 'itineraries.actions.experiences' | transloco }}</h5>
                            </div>
                            <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic() && this.singleItinerary.experiences[i].experiencesPerDay.length > 0"
                                 (click)="this.experiencesReorder(i)">
                              <lucide-icon name="refresh-cw" class="flex cursor-pointer remarksTitle-url-icon"></lucide-icon>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf=" this.singleItinerary.experiences[i].experiencesPerDay.length > 0; else noExperiencesBlock">
                          <div
                            *ngFor="let  experience of  this.singleItinerary.experiences[i].experiencesPerDay; let experiencesPerDayIndex = index">
                            <div *ngIf="experience.experience !== undefined; else noExperiencesBlock"
                                 class="group bg-experience w-auto h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
                              <div class="ps-4 flex items-center ">
                                <span class="text-lg sm:text-2xl" nz-icon nzType="fire" nzTheme="fill"></span>
                                <h5 *ngIf="experience?.isCustomTitle" class="px-3 cursor-pointer sm:text-xl text-base "
                                    (click)="viewExperiencesContent(this.singleItinerary, experience)">
                                  {{ experience.customTitle }}
                                </h5>
                                <h5 *ngIf="!experience?.isCustomTitle" class="px-3 cursor-pointer sm:text-xl text-base "
                                    (click)="viewExperiencesContent(this.singleItinerary, experience)">
                                  {{ displayTitle(experience.experience.titles, this.singleItinerary.tour.language) }}
                                </h5>
                              </div>
                              <!-- Default: info tags -->
                              <div class="flex items-center gap-2 pe-4 group-hover:hidden">
                                <span *ngIf="experience?.time" class="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-gray-300 bg-white text-gray-600 text-sm">
                                  <span nz-icon nzType="clock-circle" nzTheme="outline"></span>
                                  {{ experience.time }}
                                </span>
                                <span *ngIf="experience?.conditionType && experience.conditionType !== 'NA'"
                                      class="inline-flex items-center gap-1 px-2 py-1 rounded-md border text-sm"
                                      [ngClass]="{
                                        'border-green-300 bg-green-50 text-green-600': experience.conditionType === 'INC',
                                        'border-red-300 bg-red-50 text-red-600': experience.conditionType === 'EXC',
                                        'border-blue-300 bg-blue-50 text-blue-600': experience.conditionType === 'OPT'
                                      }">
                                  <span *ngIf="experience.conditionType === 'INC'" nz-icon nzType="check" nzTheme="outline"></span>
                                  <span *ngIf="experience.conditionType === 'EXC'" nz-icon nzType="close" nzTheme="outline"></span>
                                   <span *ngIf="experience.conditionType === 'OPT'" nz-icon nzType="check" nzTheme="outline"></span>
                                  {{ getConditionTypeLabel(experience.conditionType) }}
                                </span>
                              </div>

                              <!-- Hover: action buttons -->
                              <div class="hidden group-hover:flex pe-4 items-center">
                                <span class=" text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                      nzType="eye"
                                      nzTheme="outline"
                                      (click)="viewExperiencesContent(this.singleItinerary, experience)">
                                </span>
                                <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()" class="text-[#7C37DA]  text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                      nzType="edit"
                                      nzTheme="outline"
                                      (click)="addEditExperiencesContent(this.singleItinerary,
                                      this.findExperienceIndex(this.singleItinerary.experiences, experience.experience._id),
                                      SETTINGS.ITINERARY_CONTENT_MODE.EDIT,
                                      experience.experience.entryType === 'google' ? experience.experience.apiId : experience.experience._id,
                                      experience.experience.entryType, experience.featuredExperience, experience.notes, day?.destination?.country,i , experiencesPerDayIndex )">
                                </span>
                                <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()"
                                    nz-popconfirm
                                    [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteExperienceConfirm' | transloco"
                                    nzPopconfirmPlacement="top"
                                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                    (nzOnConfirm)="onConfirmDeleteExperiences( i,experiencesPerDayIndex ,{ experiences: this.singleItinerary.experiences})"
                                    (nzOnCancel)="cancel()"
                                    class="text-[#F96074] cursor-pointer">
                                      <lucide-icon name="trash-2" class="icon-size-2"></lucide-icon>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-template #noExperiencesBlock>
                          <p>{{ 'itineraries.addEditItinerary.itinerarySection.noExperiencesForDay' | transloco }}</p>
                        </ng-template>
                      </div>
                      <div
                        *ngIf="!day.isLeisureDay && (!departureBoxChecked || i !== this.singleItinerary?.days.length - 1)"
                        class="md:col-span-12 lg:col-span-12">
                        <div>
                          <div class="mb-2 flex items-center">
                            <div>
                              <h5 class="font-semibold">{{ 'itineraries.addEditItinerary.itinerarySection.accommodationHotels' | transloco }}</h5>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="this.accommodations.length !== 0; else noAccommodationBlock">
                          <div *ngFor="let accommodation of this.accommodations;"
                               class="group bg-accommodation w-auto h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
                            <div class="ps-4 flex items-center ">
                              <span class="text-lg sm:text-2xl" nz-icon nzType="home" nzTheme="fill"></span>
                              <h5
                                (click)="viewAccommodationContent(accommodation, this.singleItinerary.tour.currency, this.singleItinerary.tour.pax,
                                this.singleItinerary.tour?.secondaryCurrency || '',this.singleItinerary.tour?.exchangeRate || 0, this.singleItinerary)"
                                class="px-3 cursor-pointer sm:text-xl text-base">{{ accommodation.name }}</h5>
                            </div>
                            <div  class="invisible group-hover:visible pe-4 flex items-center">
                              <span class=" text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                    nzType="eye"
                                    nzTheme="outline"
                                    (click)="viewAccommodationContent(accommodation, this.singleItinerary.tour.currency, this.singleItinerary.tour.pax,
                                    this.singleItinerary.tour?.secondaryCurrency || '',this.singleItinerary.tour?.exchangeRate || 0, this.singleItinerary)">
                              </span>
                              <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()" class="text-[#7C37DA]  text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                    nzType="edit"
                                      nzTheme="outline"
                                      (click)="addEditAccommodationsContent(this.singleItinerary, SETTINGS.ITINERARY_CONTENT_MODE.EDIT, accommodation._id, day?.destination?.country)"></span>
                                <span  *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()"
                                      nz-popconfirm
                                      [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteAccommodationConfirm' | transloco"
                                      nzPopconfirmPlacement="top"
                                      [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                      [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                      (nzOnConfirm)="onConfirmDeleteAccommodation( accommodation._id, { accommodation: this.singleItinerary.accommodation})"
                                      (nzOnCancel)="cancel()"
                                      class="text-[#F96074] cursor-pointer" >
                                      <lucide-icon name="trash-2" class="icon-size-2"></lucide-icon>
                              </span>
                            </div>
                          </div>
                        </div>
                        <ng-template #noAccommodationBlock>
                          <p>{{ 'itineraries.addEditItinerary.itinerarySection.noAccommodationForDay' | transloco }}</p>
                        </ng-template>
                      </div>
                      <div class="md:col-span-12 lg:col-span-12">
                        <div>
                          <div class="mb-2 flex items-center">
                            <div>
                              <h5 class="font-semibold">{{ 'itineraries.actions.transport' | transloco }}</h5>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="this.singleItinerary.days[i].transport.length !== 0; else noTransportBlock">
                          <div
                            *ngFor="let transport of this.singleItinerary.days[i].transport; let transportIndex = index"
                            class="group bg-transport w-auto  h-auto min-h-16 flex justify-between items-center rounded-lg mt-2 ">
                            <div class="ps-4 flex items-center ">
                              <span class="text-lg sm:text-2xl" nz-icon nzType="car" nzTheme="fill"></span>
                              <h5 class="px-3 cursor-pointer sm:text-xl text-base"
                                  (click)="viewTransportContent(transport, this.singleItinerary.tour.currency,
                                  this.singleItinerary.tour.pax, this.singleItinerary.tour?.secondaryCurrency || '', this.singleItinerary.tour.exchangeRate || 0, this.singleItinerary)">
                                {{ transport.displayNameFrom }}
                                <span nz-icon nzType="arrow-right"
                                      nzTheme="outline"></span> {{ transport.displayNameTo }}
                              </h5>
                            </div>
                            <div   class="invisible group-hover:visible pe-4 flex items-center">
                              <span class=" text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                    nzType="eye"
                                    nzTheme="outline"
                                    (click)="viewTransportContent(transport, this.singleItinerary.tour.currency,
                                    this.singleItinerary.tour.pax, this.singleItinerary.tour?.secondaryCurrency || '', this.singleItinerary.tour.exchangeRate || 0, this.singleItinerary)">
                              </span>
                              <span *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()" class="text-[#7C37DA]  text-lg sm:text-2xl cursor-pointer mr-3" nz-icon
                                    nzType="edit"
                                    nzTheme="outline"
                                    (click)="addEditTransportContent(this.singleItinerary, SETTINGS.ITINERARY_CONTENT_MODE.EDIT, transportIndex, i, day?.destination?.country)"></span>
                              <span
                                *ngIf="!this.singleItinerary?.readOnly && !this.determineStatusLogic()"
                                nz-popconfirm
                                [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteTransportConfirm' | transloco"
                                nzPopconfirmPlacement="top"
                                [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                (nzOnConfirm)="onConfirmDeleteTransport( i,transportIndex, { days: this.singleItinerary.days})"
                                (nzOnCancel)="cancel()"
                                class="text-[#F96074] cursor-pointer" >
                              <lucide-icon name="trash-2" class="icon-size-2"></lucide-icon>
                            </span>
                            </div>
                          </div>
                        </div>
                        <ng-template #noTransportBlock>
                          <p>{{ 'itineraries.addEditItinerary.itinerarySection.noTransportForDay' | transloco }}</p>
                        </ng-template>
                      </div>
                      <div class="md:col-span-12 lg:col-span-12">
                        <div class="mb-2 flex  items-center justify-between">
                           <div class="flex flex-row gap-5">
                             <div>
                               <p class="font-semibold">{{day?.remarksTitle ? day?.remarksTitle : ('itineraries.addEditItinerary.itinerarySection.dayHighlights' | transloco)}}</p>
                             </div>
                             <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()" (click)="onOpenRemarksModal(day.remarksTitle, this.singleItinerary.tour.language)">
                                 <lucide-icon name="square-pen" class="flex remarksTitle-url-icon cursor-pointer"></lucide-icon>
                             </div>
                           </div>
                         </div>
                        <ng-template #aiHighlightButton let-index="index">
                          <button class="ai-button flex items-center" nz-button nzType="default"
                                  [disabled]="this.isDisableHighlightButton(index) || this.determineStatusLogic()"
                                  (click)="this.getGeneratedHighlighContent(this.singleItinerary, index)">
                            <span nz-icon nzType="plus"></span>
                            {{!this.isAiHighlightPresent ? ('itineraries.addEditItinerary.itinerarySection.generate' | transloco) :  ('itineraries.addEditItinerary.itinerarySection.regenerate' | transloco)}}
                          </button>
                        </ng-template>
                        <ng-template #aiHighlightButtonWithTooltip let-index="index">
                          <button class="ai-button flex items-center" nz-button nzType="default"
                                  nz-tooltip
                                  [disabled]="this.isDisableHighlightButton(index) || this.determineStatusLogic()"
                                  (click)="this.getGeneratedHighlighContent(this.singleItinerary, index)"
                                  [nzTooltipTitle]="'itineraries.addEditItinerary.itinerarySection.generateHighlightsTooltip' | transloco">
                            <span nz-icon nzType="plus"></span>
                            {{!this.isAiHighlightPresent ? ('itineraries.addEditItinerary.itinerarySection.generate' | transloco) :  ('itineraries.addEditItinerary.itinerarySection.regenerate' | transloco)}}
                          </button>
                        </ng-template>
                           <div class="relative">
                             <quill-editor
                             class="w-full h-48"
                             [modules]="remarksTipsQuillModules"
                             (onEditorCreated)="onRemarksTipsEditorCreated($event)"
                             [placeholder]="'itineraries.addEditItinerary.itinerarySection.addRemarksOrTips' | transloco"
                             [(ngModel)]="this.remarksTips"
                             (ngModelChange)="remarksTipsOnChange($event,i)"
                             [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                             [ngModelOptions]="{standalone: true}">
                               <div quill-editor-toolbar>
                                 <div class="ql-formats">
                                   <button class="ql-bold"></button>
                                   <button class="ql-italic"></button>
                                 </div>
                                 <div class="ql-formats">
                                   <button class="ql-list" value="ordered"></button>
                                   <button class="ql-list" value="bullet"></button>
                                 </div>
                                 <div class="ql-formats">
                                   <button class="ql-link"></button>
                                 </div>
                               </div>
                             </quill-editor>
                             <div class="absolute top-1 right-2 z-10">
                               <ng-container *ngIf="this.singleItinerary.days.length - 1 !== i">
                                 <ng-container [ngTemplateOutlet]="this.isDisableHighlightButton(i) ? aiHighlightButtonWithTooltip : aiHighlightButton" [ngTemplateOutletContext]="{ index: i }"></ng-container>
                               </ng-container>
                               <ng-container *ngIf="this.singleItinerary.days.length - 1 === i">
                                 <ng-container *ngIf="this.departureBoxChecked">
                                   <button *ngIf="!this.isDisableHighlightDepatureButton(i)" class="ai-button flex items-center" nz-button nzType="default"
                                           [disabled]="this.isDisableHighlightDepatureButton(i)"
                                           (click)="this.getGeneratedHighlighDepatureContent(this.singleItinerary, i)">
                                     <span nz-icon nzType="plus"></span>
                                     {{!this.isAiHighlightPresent ? ('itineraries.addEditItinerary.itinerarySection.generate' | transloco) :  ('itineraries.addEditItinerary.itinerarySection.regenerate' | transloco)}}
                                   </button>
                                   <button *ngIf="this.isDisableHighlightDepatureButton(i)" class="ai-button flex items-center" nz-button nzType="default"
                                           nz-tooltip
                                           [disabled]="this.isDisableHighlightDepatureButton(i)"
                                           (click)="this.getGeneratedHighlighDepatureContent(this.singleItinerary, i)"
                                           [nzTooltipTitle]="'itineraries.addEditItinerary.itinerarySection.generateDepartureHighlightsTooltip' | transloco">
                                     <span nz-icon nzType="plus"></span>
                                     {{!this.isAiHighlightPresent ? ('itineraries.addEditItinerary.itinerarySection.generate' | transloco) :  ('itineraries.addEditItinerary.itinerarySection.regenerate' | transloco)}}
                                   </button>
                                 </ng-container>
                                 <ng-container *ngIf="!this.departureBoxChecked">
                                   <ng-container [ngTemplateOutlet]="this.isDisableHighlightButton(i) ? aiHighlightButtonWithTooltip : aiHighlightButton" [ngTemplateOutletContext]="{ index: i }"></ng-container>
                                 </ng-container>
                               </ng-container>
                             </div>
                           </div>
                        <div class="mt-4">
                          <ng-template #dayCostPrefixPercent></ng-template>
                          <ng-template #dayCostPrefixFixed>{{ singleItinerary?.tour?.currency | uppercase }}</ng-template>
                          <div class="flex flex-row items-center justify-between">
                            <div>
                              <h5>{{ 'itineraries.addEditItinerary.itinerarySection.additionalCostingDay' | transloco:{ day: i + 1, date: (!this.singleItinerary.tour.isDatesOptional ? (' (' + (day?.date | date) + ')') : '') } }}</h5>
                            </div>
                            <div>
                              <span
                                *ngIf="!toggleDayAdditionalCosts[i]"
                                nz-icon
                                class="hover:cursor-pointer"
                                nzType="down"
                                nzTheme="outline"
                                (click)="toggleDayAdditionalCosts[i] = true"></span>
                              <span
                                *ngIf="toggleDayAdditionalCosts[i]"
                                nz-icon
                                nzType="up"
                                class="hover:cursor-pointer"
                                nzTheme="outline"
                                (click)="toggleDayAdditionalCosts[i] = false"></span>
                            </div>
                          </div>
                          <div *ngIf="toggleDayAdditionalCosts[i]">
                            <nz-divider></nz-divider>
                            <div>
                              <div
                                *ngFor="let dayCost of getDayAdditionalCosts(i); let costIndex = index"
                                class="flex flex-row gap-3 mb-1">
                                <nz-form-item class="flex-1 grid grid-cols-2 gap-3 mb-1">
                                  <nz-form-control>
                                    <nz-input-group>
                                      <input
                                        nz-input
                                        type="text"
                                        class="w-full"
                                        [placeholder]="'itineraries.addEditItinerary.itinerarySection.additionalCostTitle' | transloco"
                                        [(ngModel)]="dayCost.title"
                                        [ngModelOptions]="{ standalone: true }" />
                                    </nz-input-group>
                                  </nz-form-control>
                                  <nz-form-control>
                                    <nz-input-group
                                      [nzPrefix]="dayCost.costCalSymbol === 'FIXED' ? dayCostPrefixFixed : dayCostPrefixPercent"
                                      class="pr-0 py-0 prefix-custom">
                                      <nz-input-number
                                        [nzFormatter]="formatter"
                                        [nzParser]="parser"
                                        [nzPrecision]="2"
                                        [nzStep]="0.01"
                                        class="border-none"
                                        style="width: 90%"
                                        [nzPlaceHolder]="dayCost.costCalSymbol === 'FIXED'
                                          ? ('itineraries.addEditItinerary.itinerarySection.amount' | transloco)
                                          : ('itineraries.addEditItinerary.itinerarySection.percentage' | transloco)"
                                        [(ngModel)]="dayCost.cost"
                                        [ngModelOptions]="{ standalone: true }"
                                        (ngModelChange)="newCalculateTotalCost()"></nz-input-number>
                                      <!-- <nz-select
                                        [(ngModel)]="dayCost.costCalSymbol"
                                        [ngModelOptions]="{ standalone: true }"
                                        style="width: 40%">
                                        <nz-option
                                          *ngFor="let op of fixedPercentSymbol"
                                          [nzValue]="op.value"
                                          [nzLabel]="op.label"></nz-option>
                                      </nz-select> -->
                                    </nz-input-group>
                                  </nz-form-control>
                                </nz-form-item>
                                <div class="flex justify-center" *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()">
                                  <button
                                    nz-button
                                    nzDanger
                                    nzType="default"
                                    nz-popconfirm
                                    [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteAdditionalCostConfirm' | transloco"
                                    nzPopconfirmPlacement="bottom"
                                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                    (nzOnConfirm)="removeDayAdditionalCost(i, costIndex)"
                                    (nzOnCancel)="cancel()">
                                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              *ngIf="getDayAdditionalCosts(i).length > 0"
                              class="flex justify-between items-center bg-base-200 px-3 py-2 mb-2 rounded">
                              <span class="text-sm font-medium">{{ 'itineraries.addEditItinerary.itinerarySection.total' | transloco }}</span>
                              <span class="text-sm font-semibold">
                                {{
                                  getDayAdditionalCostsSubtotal(i)
                                    | currency : singleItinerary?.tour?.currency : 'symbol' : '1.2-2' | space
                                }}
                              </span>
                            </div>
                            <button
                              class="mb-4 mt-2"
                              nz-button
                              nzType="default"
                              [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                              (click)="addDayAdditionalCost(i)">
                              {{ 'itineraries.addEditItinerary.itinerarySection.addCost' | transloco }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="md:col-span-12 lg:col-span-12">
                        <div class="mt-4">
                          <div class="flex flex-row items-center justify-between">
                            <div>
                              <h5>{{ 'itineraries.addEditItinerary.itinerarySection.inclusionsExclusionsDay' | transloco:{ day: i + 1, date: (!this.singleItinerary.tour.isDatesOptional ? (' (' + (day?.date | date) + ')') : '') } }}</h5>
                            </div>
                            <div>
                              <span
                                *ngIf="!toggleDayInclusionsExclusions[i]"
                                nz-icon
                                class="hover:cursor-pointer"
                                nzType="down"
                                nzTheme="outline"
                                (click)="toggleDayInclusionsExclusions[i] = true"></span>
                              <span
                                *ngIf="toggleDayInclusionsExclusions[i]"
                                nz-icon
                                nzType="up"
                                class="hover:cursor-pointer"
                                nzTheme="outline"
                                (click)="toggleDayInclusionsExclusions[i] = false"></span>
                            </div>
                          </div>
                          <div *ngIf="toggleDayInclusionsExclusions[i]">
                            <nz-divider></nz-divider>
                            <!-- Inclusions -->
                            <div class="mb-6">
                              <div class="flex justify-between items-center mb-3">
                                <h6 class="mb-0">{{ 'otherContent.tabs.inclusions' | transloco }}</h6>
                                <button
                                  nz-button
                                  nzType="default"
                                  [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                  (click)="addDayInclusion(i)">
                                  {{ 'itineraries.addEditItinerary.itinerarySection.addInclusions' | transloco }}
                                </button>
                              </div>
                              <div *ngFor="let inclusion of singleItinerary.days[i].inclusions; let incIndex = index; trackBy: trackByIndex" class="flex gap-3 mb-3 items-start">
                                <div class="flex-1">
                                   <input
                                     nz-input
                                     class="w-full"
                                     [(ngModel)]="singleItinerary.days[i].inclusions[incIndex]"
                                     [ngModelOptions]="{standalone: true}"
                                     [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                     type="text" />
                                </div>
                                <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()">
                                  <button
                                    nz-button
                                    nzDanger
                                    nzType="default"
                                    nz-popconfirm
                                    [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteInclusionConfirm' | transloco"
                                    nzPopconfirmPlacement="bottom"
                                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                    (nzOnConfirm)="removeDayInclusion(i, incIndex)"
                                    (nzOnCancel)="cancel()">
                                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <nz-divider></nz-divider>
                            <!-- Exclusions -->
                            <div>
                              <div class="flex justify-between items-center mb-3">
                                <h6 class="mb-0">{{ 'otherContent.tabs.exclusions' | transloco }}</h6>
                                <button
                                  nz-button
                                  nzType="default"
                                  [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                  (click)="addDayExclusion(i)">
                                  {{ 'itineraries.addEditItinerary.itinerarySection.addExclusions' | transloco }}
                                </button>
                              </div>
                              <div *ngFor="let exclusion of singleItinerary.days[i].exclusions; let excIndex = index; trackBy: trackByIndex" class="flex gap-3 mb-3 items-start">
                                <div class="flex-1">
                                   <input
                                     nz-input
                                     class="w-full"
                                     [(ngModel)]="singleItinerary.days[i].exclusions[excIndex]"
                                     [ngModelOptions]="{standalone: true}"
                                     [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                                     type="text" />
                                </div>
                                <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()">
                                  <button
                                    nz-button
                                    nzDanger
                                    nzType="default"
                                    nz-popconfirm
                                    [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteExclusionConfirm' | transloco"
                                    nzPopconfirmPlacement="bottom"
                                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                    (nzOnConfirm)="removeDayExclusion(i, excIndex)"
                                    (nzOnCancel)="cancel()">
                                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nz-tab>
              </nz-tabset>
            </div>
          </form>
        </nz-card>
      </div>
      <div class="lg:col-span-5 md:col-span-12" id="cost-details-section">
        <nz-card *ngIf="!this.isDynamicPricing">
          <div class="flex flex-row justify-between gap-2">
            <h5>
              {{ 'itineraries.addEditItinerary.itinerarySection.tourCosting' | transloco }}
            </h5>
            <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()" class="ml-2">
              <button
                nz-button
                nzType="default"
                nz-popconfirm
                [nzPopconfirmTitle]="
                  ('itineraries.addEditItinerary.itinerarySection.switchPricingConfirm' | transloco) +
                  ' ' +
                  (isDynamicPricing
                    ? ('itineraries.addEditItinerary.itinerarySection.switchAutoPricing' | transloco)
                    : ('itineraries.addEditItinerary.itinerarySection.switchSeasonalPricing' | transloco)) + '?'
                "
                nzPopconfirmPlacement="bottom"
                [nzOkText]="'itineraries.modals.common.ok' | transloco"
                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                (nzOnConfirm)="dynamicPricingOnChange(!isDynamicPricing)"
                (nzOnCancel)="cancel()"
              >
                {{ isDynamicPricing
                  ? ('itineraries.addEditItinerary.itinerarySection.switchAutoPricing' | transloco)
                  : ('itineraries.addEditItinerary.itinerarySection.switchSeasonalPricing' | transloco) }}
              </button>
            </div>
          </div>
          <nz-divider></nz-divider>
          <ng-container *ngIf="this.costingForm.get('viewType').value !== 'custom'">
            <div class="mb-5" *ngIf="this.isSubTotalManual">
              <nz-alert nzType="warning"
                        [nzMessage]="'itineraries.addEditItinerary.itinerarySection.manualSubtotalWarning' | transloco"
                        nzShowIcon>
              </nz-alert>
            </div>
            <form nz-form [formGroup]="costingForm">
              <div class="flex flex-row justify-between">
                <nz-form-item>
                  <nz-form-label
                    class="w-1/5 md:w-1/4 lg:w-1/3 text-start"
                    nzRequired
                    nzFor="totalCost"
                  >{{ 'itineraries.costBreakdown.costing.subTotal' | transloco }}
                  </nz-form-label>
                  <nz-form-control nzValidateStatus="{{!daysArrFormValid ? 'error' : '' }}"
                                   nzErrorTip="{{!daysArrFormValid ? ('itineraries.addEditItinerary.itinerarySection.autoCalculationError' | transloco) : '' }}">
                    <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 prefix-custom">
                      <nz-input-number
                        [nzFormatter]="formatter"
                        [nzParser]="parser"
                        [nzPrecision]="2"
                        [nzStep]="0.01"
                        class="w-full border-none"
                        [nzMin]="0"
                        [nzPlaceHolder]="'itineraries.addEditItinerary.itinerarySection.amount' | transloco"
                        formControlName="totalCost"></nz-input-number>
                    </nz-input-group>
                    <ng-template #prefixCurrency>{{
                        singleItinerary?.tour?.currency | uppercase
                      }}
                    </ng-template>
                    <ng-template #calcButton>
                      <button
                        nz-button
                        nzType="primary"
                        (click)="calculateTotalCost()">
                        {{ 'itineraries.addEditItinerary.itinerarySection.calculate' | transloco }}
                      </button>
                    </ng-template>
                  </nz-form-control>
                </nz-form-item>
                <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()" class="mt-1.5 ml-3">
                  <lucide-icon *ngIf="!this.isSubTotalManual"
                               class="pencil-icons flex cursor-pointer"
                               name="pencil"
                                nz-popconfirm
                                [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.switchManualCostingConfirm' | transloco"
                                nzPopconfirmPlacement="bottom"
                                [nzOkText]="'itineraries.modals.common.ok' | transloco"
                                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                (nzOnConfirm)="totalCostOnChange(true)"
                                (nzOnCancel)="cancel()">
                  </lucide-icon>
                  <lucide-icon *ngIf="this.isSubTotalManual"
                               class="pencil-icons flex cursor-pointer"
                               name="pencil-off"
                                nz-popconfirm
                                [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.switchAutomaticCostingConfirm' | transloco"
                                nzPopconfirmPlacement="bottom"
                                [nzOkText]="'itineraries.modals.common.ok' | transloco"
                                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                (nzOnConfirm)="totalCostOnChange(false)"
                                (nzOnCancel)="cancel()">
                  </lucide-icon>
                </div>
              </div>
              <nz-form-item *ngIf="this.brand?.isMarkCostBefore" class="flex flex-row justify-between gap-x-12">
                <nz-form-label
                  class="text-start"
                  nzRequired
                  nzFor="markup"
                >{{ 'itineraries.costBreakdown.costing.markup' | transloco }}
                </nz-form-label>
                <nz-form-control>
                  <nz-input-group
                    [nzPrefix]="costingForm.get('markupSymbol').value ===  'FIXED' ? prefixFixedCurrency : prefixPercentCurrency"
                    class="pr-0 py-0 prefix-custom">
                    <nz-input-number
                      [nzFormatter]="formatter"
                      [nzParser]="parser"
                      [nzPrecision]="2"
                      [nzStep]="0.01"
                      style="width: 70%"
                      class="border-none"
                      [nzPlaceHolder]="costingForm.get('markupSymbol').value ===  'FIXED'
                        ? ('itineraries.addEditItinerary.itinerarySection.amount' | transloco)
                        : ('itineraries.addEditItinerary.itinerarySection.percentage' | transloco)"
                      formControlName="markupRatio"></nz-input-number>
                    <nz-select formControlName="markupSymbol" style="width: 30%">
                      <nz-option *ngFor="let op of fixedPercentSymbol" [nzValue]="op.value"
                                 [nzLabel]="op.label"></nz-option>
                    </nz-select>
                  </nz-input-group>
                  <ng-template #prefixPercentCurrency>
                  </ng-template>
                  <ng-template #prefixFixedCurrency>{{
                      singleItinerary?.tour?.currency | uppercase
                    }}
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
              <h6 class="mb-2">{{ 'itineraries.costBreakdown.additionalCosts.title' | transloco }}</h6>
              <div>
                <div
                  formArrayName="additionalCosts"
                  *ngFor="
                  let additional of getAdditionalCosts().controls;
                  let costIndex = index" class="flex flex-row gap-3">
                  <nz-form-item
                    [attr.draggable]="true"
                    (dragstart)="onCostDragStart($event, costIndex)"
                    (dragover)="onCostDragOver($event)"
                    (drop)="onCostDrop($event, costIndex)"
                    class="grid grid-cols-2 gap-3 mb-1"
                    [formGroupName]="costIndex">
                    <nz-form-control>
                      <nz-input-group style="border-radius: 0.375rem !important;">
                        <input
                          nz-input
                          type="text"
                          [disabled]="costingForm.get('additionalCosts').at(costIndex).value.entryType === 'PRE' ?
                          this.costingForm.get('additionalCosts').at(costIndex).get('title').disable() : false "
                          class="w-full"
                          style="border-radius: 0.375rem !important;"
                          [placeholder]="'itineraries.costBreakdown.costing.titleColumn' | transloco"
                          formControlName="title" />
                      </nz-input-group>
                    </nz-form-control>
                    <nz-form-control>
                      <nz-input-group
                        [nzPrefix]="costingForm.get('additionalCosts').at(costIndex).value.costCalSymbol ===  'FIXED' ? prefixFixedCurrency : prefixPercentCurrency"
                        class="pr-0 py-0 prefix-custom"
                        style="border-radius: 0.375rem !important;">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          [nzStep]="0.01"
                          [nzDisabled]="costingForm.get('additionalCosts').at(costIndex).value.entryType === 'PRE'"
                          class="border-none"
                          style="width: 60%"
                          [nzPlaceHolder]="costingForm.get('additionalCosts').at(costIndex).value.costCalSymbol ===  'FIXED' ? ('itineraries.costBreakdown.costing.amount' | transloco) : ('itineraries.costBreakdown.costing.percentage' | transloco)"
                          formControlName="cost"></nz-input-number>
                        <nz-select formControlName="costCalSymbol" style="width: 40%"
                                   [nzDisabled]="costingForm.get('additionalCosts').at(costIndex).value.entryType === 'PRE'">
                          <nz-option *ngFor="let op of fixedPercentSymbol" [nzValue]="op.value"
                                     [nzLabel]="op.label"></nz-option>
                        </nz-select>
                      </nz-input-group>
                      <ng-template #prefixPercentCurrency>
                      </ng-template>
                      <ng-template #prefixFixedCurrency>{{
                          singleItinerary?.tour?.currency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                  <ng-container *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()">
                  <div class="flex justify-center"
                       *ngIf="costingForm.get('additionalCosts').at(costIndex).value.entryType === 'PRE'">
                    <button nz-button nzType="primary"
                            nz-popconfirm
                            [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.editPredefinedCostingConfirm' | transloco"
                            nzPopconfirmPlacement="bottom"
                            [nzOkText]="'itineraries.modals.common.ok' | transloco"
                            [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                            (nzOnConfirm)="this.editPreDefinedAdditionalCost(costIndex)"
                            (nzOnCancel)="cancel()">
                      <span nz-icon nzType="edit" nzTheme="outline"></span>
                    </button>
                  </div>
                  <div class="flex justify-center"
                       *ngIf="costingForm.get('additionalCosts').at(costIndex).value.entryType === 'PRE';else altMessage">
                    <button nz-button nzDanger nzType="default"
                            nz-popconfirm
                            [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deletePredefinedCostingConfirm' | transloco"
                            nzPopconfirmPlacement="bottom"
                            [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                            [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                            [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                            (nzOnConfirm)="this.removeAdditionalCost(costIndex)"
                            (nzOnCancel)="cancel()">
                      <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                    </button>
                  </div>
                  <ng-template #altMessage>
                    <div class="flex justify-center">
                      <button nz-button nzDanger nzType="default"
                              nz-popconfirm
                              [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteAdditionalCostingConfirm' | transloco"
                              nzPopconfirmPlacement="bottom"
                              [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                              [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                              (nzOnConfirm)="this.removeAdditionalCost(costIndex)"
                              (nzOnCancel)="cancel()">
                        <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                      </button>
                    </div>
                  </ng-template>
                  </ng-container>
                </div>
              </div>
              <button
                class="mb-4"
                nz-button
                [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                nzType="default"
                (click)="addAdditionalCost('', 0, '','', null)">
                {{ 'itineraries.addEditItinerary.itinerarySection.addCost' | transloco }}
              </button>
              <nz-form-item *ngIf="this.brand?.isMarkCostBefore !== true" class="flex">
                <nz-form-label
                  class="w-1/5 md:w-1/4 lg:w-1/3 text-start"
                  nzRequired
                  nzFor="markup"
                >{{ 'itineraries.costBreakdown.costing.markup' | transloco }}
                </nz-form-label
                >
                <nz-form-control>
                  <nz-input-group
                    [nzPrefix]="costingForm.get('markupSymbol').value ===  'FIXED' ? prefixFixedCurrency : prefixPercentCurrency"
                    class="pr-0 py-0 prefix-custom">
                    <nz-input-number
                      [nzFormatter]="formatter"
                      [nzParser]="parser"
                      [nzPrecision]="2"
                      [nzStep]="0.01"
                      style="width: 70%"
                      class="border-none"
                      [nzPlaceHolder]="costingForm.get('markupSymbol').value ===  'FIXED' ? ('itineraries.costBreakdown.costing.amount' | transloco) : ('itineraries.costBreakdown.costing.percentage' | transloco)"
                      formControlName="markupRatio"></nz-input-number>
                    <nz-select formControlName="markupSymbol" style="width: 30%">
                      <nz-option *ngFor="let op of fixedPercentSymbol" [nzValue]="op.value"
                                 [nzLabel]="op.label"></nz-option>
                    </nz-select>
                  </nz-input-group>
                  <ng-template #prefixPercentCurrency>
                  </ng-template>
                  <ng-template #prefixFixedCurrency>{{
                      singleItinerary?.tour?.currency | uppercase
                    }}
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
              <div class="flex justify-between mb-4 bg-base-200 p-4">
                <h6>{{ 'itineraries.costBreakdown.costing.totalTourCost' | transloco }}</h6>
                <h6>
                  {{
                    costingForm.get('grandTotal').value
                      | currency : singleItinerary?.tour?.currency : 'symbol' | space
                  }}
                </h6>
              </div>
            </form>
            <div class="flex justify-between mb-4 bg-base-200 p-4">
              <h6>{{ 'itineraries.costBreakdown.costing.perPersonCost' | transloco }}</h6>
              <h6>
                {{
                  costingForm.get('personCost').value | currency : singleItinerary?.tour?.currency : 'symbol' | space
                }}
              </h6>
            </div>
            <div class="flex items-center gap-6 mb-4 px-1">
            <nz-icon  nz-tooltip
                      nzTooltipPlacement = 'right'
                      [nzTooltipArrowPointAtCenter]="true"
                      [nzTooltipTitle]="'itineraries.addEditItinerary.itinerarySection.perPersonCostTooltip' | transloco"
                      class="text-primary"
                      nz-icon nzType="info-circle" nzTheme="outline">
            </nz-icon>
              <form nz-form [formGroup]="costingForm">
                <ng-container formGroupName="paxCostingChecks">
                  <label nz-checkbox formControlName="perAdult">{{ 'itineraries.addEditItinerary.form.fields.adult' | transloco }}</label>
                  <label nz-checkbox formControlName="perChild" class="ml-4">{{ 'itineraries.addEditItinerary.form.fields.children' | transloco }}</label>
                  <label nz-checkbox formControlName="perInfant" class="ml-4">{{ 'itineraries.addEditItinerary.form.fields.infant' | transloco }}</label>
                </ng-container>
              </form>
            </div>
            <div>
              <h6 class="mb-2 mt-5">{{ 'itineraries.addEditItinerary.itinerarySection.specialNotes' | transloco }}</h6>
              <form nz-form [formGroup]="this.costingForm">
                <nz-form-item>
                  <nz-form-control class="relative">
                    <div class="absolute top-1 right-2 z-10">
                      <button nz-button *ngIf="this.singleItinerary?.tour.language !== 'en'"
                        class="ai-button flex items-center" nz-button nzType="default"
                        [disabled]="!costingForm.value.pricingRemarks"
                        (click)="translateContent(
                        costingForm.value.pricingRemarks,
                        this.singleItinerary?.tour.language,
                        'pricingRemarks')">
                        <span nz-icon nzType="plus"></span>
                        {{ 'itineraries.addEditItinerary.actions.translate' | transloco }}
                      </button>
                    </div>
                    <quill-editor
                      class="w-full h-52"
                      [placeholder]="'itineraries.addEditItinerary.itinerarySection.enterSpecialNotes' | transloco"
                      formControlName="pricingRemarks">
                      <div quill-editor-toolbar>
                        <div class="ql-formats">
                          <button class="ql-bold"></button>
                          <button class="ql-italic"></button>
                        </div>
                        <div class="ql-formats">
                          <button class="ql-list" value="ordered"></button>
                          <button class="ql-list" value="bullet"></button>
                        </div>
                      </div>
                    </quill-editor>
                  </nz-form-control>
                </nz-form-item>
              </form>
            </div>
          </ng-container>
            <div class="mb-2">
              <form nz-form nzLayout="vertical" [formGroup]="costingForm">
                <nz-form-item class="mb-3">
                  <nz-form-label  nzFor="costingCurrency">{{ 'itineraries.addEditItinerary.itinerarySection.displayCostOnItinerary' | transloco }}</nz-form-label>
                    <nz-select formControlName="viewType">
                      <nz-option
                        *ngFor="let lang of this.costingType"
                        [nzValue]="lang?.value"
                        [nzLabel]="lang?.label"></nz-option>
                    </nz-select>
                </nz-form-item>
              </form>
            </div>
            <div *ngIf="this.costingForm.get('viewType').value === 'custom'">
              <form nz-form  [formGroup]="costingForm">
                  <nz-form-item class="grid grid-cols-2 gap-3 mb-1">
                    <nz-form-label class="text-start" nzFor="costPerAdult"
                    >{{ 'itineraries.costBreakdown.costing.costPerAdult' | transloco }}
                    </nz-form-label>
                    <nz-form-control>
                      <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          [nzStep]="0.01"
                          class="w-full border-none"
                          [nzMin]="0"
                          nzPlaceHolder="Amount"
                          formControlName="costPerAdult"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          singleItinerary?.tour?.currency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item class="grid grid-cols-2 gap-3 mb-1">
                    <nz-form-label class="text-start" nzFor="costPerChild"
                    >{{ 'itineraries.costBreakdown.costing.costPerChild' | transloco }}
                    </nz-form-label>
                    <nz-form-control>
                      <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          [nzStep]="0.01"
                          class="w-full border-none"
                          [nzMin]="0"
                          nzPlaceHolder="Amount"
                          formControlName="costPerChild"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          singleItinerary?.tour?.currency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item class="grid grid-cols-2 gap-3 mb-1">
                    <nz-form-label class="text-start" nzFor="costPerInfant"
                    >{{ 'itineraries.costBreakdown.costing.costPerInfant' | transloco }}
                    </nz-form-label>
                    <nz-form-control>
                      <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0" >
                        <nz-input-number
                          [nzFormatter]="formatter"
                          [nzParser]="parser"
                          [nzPrecision]="2"
                          [nzStep]="0.01"
                          class="w-full border-none"
                          [nzMin]="0"
                          nzPlaceHolder="Amount"
                          formControlName="costPerInfant"></nz-input-number>
                      </nz-input-group>
                      <ng-template #prefixCurrency>{{
                          singleItinerary?.tour?.currency | uppercase
                        }}
                      </ng-template>
                    </nz-form-control>
                  </nz-form-item>
              </form>
              <div class="mt-5">
                <nz-alert nzType="warning"
                          [nzMessage]="'itineraries.addEditItinerary.itinerarySection.customPerPersonWarning' | transloco"
                          nzShowIcon>
                </nz-alert>
              </div>
            </div>
          </nz-card>
        <nz-card *ngIf="this.isDynamicPricing">
          <div class="flex flex-row justify-between gap-2">
            <h5>
              {{ 'itineraries.addEditItinerary.itinerarySection.tourCosting' | transloco }}
            </h5>
            <div *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()" class="ml-2">
              <button
                nz-button
                nzType="default"
                nz-popconfirm
                [nzPopconfirmTitle]="
                  ('itineraries.addEditItinerary.itinerarySection.switchPricingConfirm' | transloco) +
                  ' ' +
                  (isDynamicPricing
                    ? ('itineraries.addEditItinerary.itinerarySection.switchAutoPricing' | transloco)
                    : ('itineraries.addEditItinerary.itinerarySection.switchSeasonalPricing' | transloco)) + '?'
                "
                nzPopconfirmPlacement="bottom"
                [nzOkText]="'itineraries.modals.common.ok' | transloco"
                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                (nzOnConfirm)="dynamicPricingOnChange(!isDynamicPricing)"
                (nzOnCancel)="cancel()"
              >
                {{ isDynamicPricing
                  ? ('itineraries.addEditItinerary.itinerarySection.switchAutoPricing' | transloco)
                  : ('itineraries.addEditItinerary.itinerarySection.switchSeasonalPricing' | transloco) }}
              </button>
            </div>
          </div>
          <nz-divider></nz-divider>
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold text-gray-800">{{ 'itineraries.addEditItinerary.itinerarySection.seasonalPricing' | transloco }}</h2>
          </div>
          <div class="overflow-x-auto rounded-lg border border-gray-200">
            <table class="w-full table-auto">
              <thead class="bg-gray-50">
              <tr>
                <ng-container *ngFor="let headerCtrl of headersFA.controls; let c = index">
                  <th class="border-b border-gray-200 px-4 py-3 text-left text-sm font-semibold text-gray-700">
                    <div class="flex flex-col justify-center gap-2">
                    {{headerCtrl.get('name')?.value}}
                      <div class="flex flex-row justify-start gap-2">
                        <lucide-icon
                          name="pencil"
                          class="icon-size cursor-pointer"
                          [class.text-gray-300]="determineStatusLogic()"
                          [class.text-blue-500]="!determineStatusLogic()"
                          [class.pointer-events-none]="determineStatusLogic()"
                          nz-popconfirm
                          (nzOnCancel)="cancel()"
                          [nzPopconfirmTitle]="'itineraries.addEditItinerary.seasonalPricing.editColumnConfirm' | transloco"
                          [nzOkText]="'itineraries.modals.common.ok' | transloco"
                          [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                          (nzOnConfirm)="this.seasonalPricingOpenModal('edit', c)"
                        ></lucide-icon>
                        <lucide-icon
                          *ngIf="c !== 0"
                          name="trash-2"
                          class="icon-size cursor-pointer"
                          [class.text-gray-300]="determineStatusLogic()"
                          [class.text-red-500]="!determineStatusLogic()"
                          [class.pointer-events-none]="determineStatusLogic()"
                          nz-popconfirm
                          (nzOnCancel)="cancel()"
                          [nzPopconfirmTitle]="'itineraries.addEditItinerary.seasonalPricing.deleteColumnConfirm' | transloco"
                          [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                          [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                          (nzOnConfirm)="deleteColumn(c)"
                        ></lucide-icon>
                      </div>
                    </div>
                  </th>
                </ng-container>
                <th class="border-b border-gray-200 px-4 py-3 text-left text-sm font-semibold text-gray-700"></th>
              </tr>
              </thead>

              <tbody>
              <tr *ngFor="let rowFA of rowsFA.controls; let r = index" class="odd:bg-white even:bg-gray-50">
                <ng-container *ngFor="let _ of headersFA.controls; let c = index">
                  <td *ngIf="_.get('isCostColumn')?.value === true" class="border-t border-gray-200 px-4 py-3">
                    <input
                      *ngIf="c === 0"
                      [formControl]="cellControl(r, c)"
                      type="text"
                      class="w-full rounded-md border border-gray-200 bg-transparent px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
                      [placeholder]="'itineraries.addEditItinerary.form.fields.numberOfPax' | transloco"
                    />
                    <nz-input-number
                      *ngIf="c !== 0"
                      [formControl]="cellControl(r, c)"
                      [nzFormatter]="formatter"
                      [nzParser]="parser"
                      [nzPrecision]="2"
                      [nzStep]="0.01"
                      class="w-full rounded-md border border-gray-200 bg-transparent text-sm focus:outline-none focus:ring-2 focus:ring-violet-300 pax-input"
                      [nzPlaceHolder]="'itineraries.addEditItinerary.itinerarySection.zeroAmount' | transloco"
                    ></nz-input-number>
                  </td>
                  <td *ngIf="_.get('isCostColumn')?.value === false" class="border-t border-gray-200 px-4 py-3">
                    <input
                      [formControl]="cellControl(r, c)"
                      [type]="c === 0 ? 'text' : 'text'"
                      class="w-full rounded-md border border-gray-200 bg-transparent px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-violet-300"
                      [placeholder]="c === 0
                        ? ('itineraries.addEditItinerary.form.fields.numberOfPax' | transloco)
                        : ('itineraries.common.emptyValue' | transloco)"
                    />
                  </td>
                </ng-container>

                <!-- Delete Row Button -->
                <td class="border-t border-gray-200 px-4 py-3 text-center">
                  <button
                    nzSize="small"
                    nz-button
                    nzType="default"
                    nzDanger
                    [disabled]="determineStatusLogic()"
                    (nzOnConfirm)="deleteRow(r)"
                    nz-popconfirm
                    (nzOnCancel)="cancel()"
                    [nzPopconfirmTitle]="'itineraries.addEditItinerary.itinerarySection.deleteRowConfirm' | transloco"
                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                    class="flex items-center justify-center gap-2">
                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="flex justify-end mt-5 gap-2" *ngIf="!determineStatusLogic()">
            <button
              nz-button
              nzType="default"
              nzSize="small"
              (click)="addRow()"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="plus" class="icon-size"></lucide-icon>
              {{ 'itineraries.addEditItinerary.itinerarySection.addRow' | transloco }}
            </button>
            <button
              nz-button
              nzType="default"
              nzSize="small"
              (click)="this.seasonalPricingOpenModal('new', null)"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="plus" class="icon-size"></lucide-icon>
              {{ 'itineraries.addEditItinerary.itinerarySection.addColumn' | transloco }}
            </button>
          </div>
          <div>
            <div class="flex flex-row items-center justify-between gap-5 mt-5">
              <h6 class="mb-2">{{ 'itineraries.addEditItinerary.itinerarySection.specialNotes' | transloco }}</h6>
              <button nz-button *ngIf="this.singleItinerary?.tour.language !== 'en'"
                class="ai-button flex items-center" nz-button nzType="default"
                [disabled]="!costingForm.value.pricingRemarks"
                (click)="translateContent(
                costingForm.value.pricingRemarks,
                this.singleItinerary?.tour.language,
                'pricingRemarks')">
                <span nz-icon nzType="plus"></span>
                {{ 'itineraries.addEditItinerary.actions.translate' | transloco }}
              </button>
            </div>
            <nz-divider></nz-divider>
            <form nz-form [formGroup]="this.costingForm">
              <nz-form-item>
                <nz-form-control>
                  <quill-editor
                    class="w-full h-52"
                    [placeholder]="'itineraries.addEditItinerary.itinerarySection.enterSpecialNotes' | transloco"
                    formControlName="pricingRemarks">
                    <div quill-editor-toolbar>
                      <div class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                      </div>
                      <div class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                      </div>
                    </div>
                  </quill-editor>
                </nz-form-control>
              </nz-form-item>
            </form>
          </div>
        </nz-card>
        <nz-card>
          <div class="flex flex-row items-center justify-between">
            <div>
              <h5>{{ 'itineraries.addEditItinerary.itinerarySection.costBreakdownOverview' | transloco }}</h5>
            </div>
            <div>
              <span *ngIf="!this.toggleCostBreakDown" nz-icon class="hover:cursor-pointer" nzType="down"
                    nzTheme="outline"
                    (click)="this.toggleCostBreakDown = true"></span>
              <span *ngIf="this.toggleCostBreakDown" nz-icon nzType="up" class="hover:cursor-pointer" nzTheme="outline"
                    (click)="this.toggleCostBreakDown = false"></span>
            </div>
          </div>
          <div *ngIf="this.toggleCostBreakDown">
            <nz-divider></nz-divider>
            <div *ngIf="!this.isSubTotalManual" class="flex justify-between mb-4 bg-base-200 p-4">
              <h6>{{ 'itineraries.costBreakdown.costingBreakdown.totalAccommodationCost' | transloco }}</h6>
              <h6>
                {{ costingForm.get('totalAccommodation').value | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
              </h6>
            </div>
            <div *ngIf="!this.isSubTotalManual" class="flex justify-between mb-4 bg-base-200 p-4">
              <h6>{{ 'itineraries.costBreakdown.costingBreakdown.totalTransportationCost' | transloco }}</h6>
              <h6>
                {{ costingForm.get('totalTransport').value | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
              </h6>
            </div>
            <div *ngIf="!this.isSubTotalManual" class="flex justify-between mb-4 bg-base-200 p-4">
              <h6>{{ 'itineraries.costBreakdown.costingBreakdown.totalExperiencesCost' | transloco }}</h6>
              <h6>
                {{ costingForm.get('totalExperiences').value | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
              </h6>
            </div>
            <div class="mb-4 bg-base-200 p-4">
              <div class="flex justify-between items-center">
                <h6 class="mb-0">{{ 'itineraries.costBreakdown.costingBreakdown.totalAdditionalCost' | transloco }}</h6>
                <h6 class="mb-0">
                  {{ (costingForm.get('totalAdditionalCost').value + getTotalAdditionalCostsPerDay()) | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
                </h6>
              </div>
              <div class="mt-3 pt-3 border-t border-gray-300 flex flex-col gap-2">
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-500 flex items-center gap-1">
                    <span nz-icon nzType="global" nzTheme="outline"></span>
                    {{ 'itineraries.addEditItinerary.itinerarySection.tourWiseTotal' | transloco }}
                  </span>
                  <span class="text-sm">
                    {{ costingForm.get('totalAdditionalCost').value | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
                  </span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-500 flex items-center gap-1">
                    <span nz-icon nzType="calendar" nzTheme="outline"></span>
                    {{ 'itineraries.addEditItinerary.itinerarySection.dayWiseTotal' | transloco }}
                  </span>
                  <span class="text-sm">
                    {{ getTotalAdditionalCostsPerDay() | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
                  </span>
                </div>
              </div>
            </div>
            <div class="flex justify-between mb-4 bg-base-200 p-4">
              <h6>{{ 'itineraries.costBreakdown.costingBreakdown.totalMarkup' | transloco }}</h6>
              <h6>
                {{ costingForm.get('markup').value | currency : singleItinerary?.tour?.currency : 'symbol' | space }}
              </h6>
            </div>
          </div>
        </nz-card>
      </div>
    </div>

  </nz-spin>
  <nz-spin [nzSpinning]="cardLoading">
    <nz-card class="my-8" id="overview-section">
      <form nz-form [formGroup]="featuredForm">
        <div>
          <h5>{{ 'itineraries.addEditItinerary.overview.title' | transloco }}</h5>
          <nz-divider></nz-divider>
          <div class="grid md:grid-cols-12 gap-6">
            <div class="md:col-span-6 lg:col-span-4">
              <div class="mb-3 hidden">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                  <input [(ngModel)]="this.searchImageText" [ngModelOptions]="{standalone: true}" type="text"
                         nz-input [placeholder]="'itineraries.addEditItinerary.overview.searchOnPexels' | transloco" />
                </nz-input-group>
                <ng-template #suffixIconButton>
                  <button nz-button nzType="primary" [disabled]="this.searchImageText === ''"
                          (click)="this.addImage(this.searchImageText)" nzSearch><span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
              </div>
              <div class="mb-3">
                <div
                  *ngIf="this.images.length !== 0 || (this.overviewImages.length !== 0 && this.featuredForm.get('image').value !== '')">
                  <div class="grid grid-cols-1" *ngIf="!this.featuredForm.get('isSliderEnabled')?.value">
                    <img class="w-full h-64 object-cover"
                         [src]="getSelectedImage()"
                         alt="" />
                  </div>

                  <div class="grid grid-cols-1">
                    <nz-radio-group
                      class="my-3 grid grid-cols-8 justify-items-center"
                      nzButtonStyle="solid"
                      [nzDisabled]="this.featuredForm.get('isSliderEnabled')?.value"
                      formControlName="image">
                      <label
                        class=" w-16 h-16 md:w-12 md:h-12 p-1 mb-5"
                        *ngFor="let img of images"
                        nz-radio-button
                        [nzValue]="img">
                        <img
                          class="w-full h-full object-cover"
                          [src]="img"
                          alt="" />
                        <ng-template #deleteSharedImageConfirmTpl>
                          <div class="flex items-start max-w-sm whitespace-normal break-words">
                            <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="text-[#faad14] mr-2 mt-1 flex-shrink-0"></span>
                            <span>{{ 'itineraries.addEditItinerary.overview.deleteSharedImageConfirm' | transloco }}</span>
                          </div>
                        </ng-template>
                        <span  *ngIf="this.singleItinerary?.lock && !this.determineStatusLogic()" nz-popconfirm
                              [nzPopconfirmTitle]="deleteSharedImageConfirmTpl"
                              nzPopconfirmPlacement="top"
                                [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                                [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                                nzOkDanger
                              (nzOnConfirm)="deleteImage(img)"
                              (nzOnCancel)="cancel()"
                               class="text-[#F96074] cursor-pointer flex justify-center mt-2">
                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                        </span>
                      </label>
                    </nz-radio-group>
                  </div>
                </div>
                <ng-container *ngIf="this.singleItinerary?.lock && !this.determineStatusLogic()">

                <div [class.flex]="this.images.length >= 1 || this.overviewImages.length >= 1"
                                     [class.justify-center]="this.images.length >= 1 || this.overviewImages.length >= 1">
                                  <nz-upload
                                    class="w-full"
                                    [class.custom-upload-size]="this.images.length === 0 && this.overviewImages.length === 0"
                                    [(nzFileList)]="fileList"
                                    [nzMultiple]="true"
                                    [nzPreview]="handlePreview"
                                    [nzCustomRequest]="customUploadReq"
                                    (nzChange)="handleChange($event)"
                                    nzListType="picture-card"
                                    nzAccept="image/png,image/jpg,image/jpeg"
                                    [nzHeaders]="setMediaUploadHeaders"
                                    [nzRemove]="onRemove"
                                    [nzShowUploadList]="false">
                                    <div *ngIf="this.images.length === 0 && this.overviewImages.length === 0">
                                      <span nz-icon nzType="upload" nzTheme="outline"></span>
                                    </div>
                                    <div class="mt-3 flex flex-col items-center justify-center w-full" *ngIf="this.images.length >= 1 || this.overviewImages.length >= 1">
                                        <span nz-icon nzType="upload" nzTheme="outline"></span>
                                        <a>{{ 'itineraries.addEditItinerary.overview.clickToUploadMore' | transloco }}</a>
                                    </div>
                                  </nz-upload>
                                </div>
                                <nz-alert class="mt-2" nzType="info" nzShowIcon
                                          [nzMessage]="'itineraries.addEditItinerary.overview.uploadHdImagesInfo' | transloco"></nz-alert>
                                </ng-container>
              </div>
              <div *ngIf="this.featuredForm.get('isSliderEnabled')?.value ? this.allImages.length !== 0 : this.overviewImages?.length !== 0">
                <div class="flex items-center justify-between mb-2">
                  <h5 class="mb-0">{{ 'itineraries.addEditItinerary.overview.allTravelImages' | transloco }}</h5>
                  <div class="flex items-center gap-2">
                    <span nz-icon nzType="info-circle" nzTheme="outline" class="text-gray-400" nz-tooltip [nzTooltipTitle]="'itineraries.addEditItinerary.overview.sliderTooltip' | transloco"></span>
                    <label class="text-sm text-gray-600">{{ 'itineraries.addEditItinerary.overview.enableSlider' | transloco }}</label>
                    <nz-switch formControlName="isSliderEnabled"></nz-switch>
                  </div>
                </div>
                <div *ngIf="this.featuredForm.get('isSliderEnabled')?.value; else sliderDisabled">
                  <div class="grid grid-cols-1">
                    <div class="my-3 grid grid-cols-5 gap-3">
                      <div
                        class="relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all"
                        [class.border-purple-700]="isImageSelected(img)"
                        [class.border-transparent]="!isImageSelected(img)"
                        *ngFor="let img of this.allImages"
                        (click)="toggleImageSelection(img)">
                        <img
                          class="w-full h-24 object-cover"
                          [src]="img"
                          alt="" />
                        <div
                          *ngIf="isImageSelected(img)"
                          class="absolute top-0 right-0 bg-purple-700 text-white text-xs font-bold w-6 h-6 flex items-center justify-center rounded-bl-lg">
                          {{ getImageSelectionIndex(img) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #sliderDisabled>
                  <div *ngIf="this.overviewImages?.length !== 0" class="grid grid-cols-1">
                    <nz-radio-group
                      class="my-3 grid grid-cols-8 justify-items-center"
                      nzButtonStyle="solid"
                      formControlName="image">
                      <label
                        class="w-16 h-16 md:w-16 md:h-16 p-1 mb-2"
                        *ngFor="let img of this.overviewImages"
                        nz-radio-button
                        [nzValue]="img">
                        <img
                          class="w-full h-full object-cover"
                          [src]="img"
                          alt="" />
                      </label>
                    </nz-radio-group>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="md:col-span-6 lg:col-span-8">
              <div class="flex justify-end mb-3">
                <button class="ai-button flex items-center" nz-button nzType="default"
                        [disabled]="this.singleItinerary?.days[0].destination === undefined || this.singleItinerary?.lock === null || this.determineStatusLogic()"
                        (click)="getGeneratedContent({days: this.singleItinerary?.days, noOfDays: this.singleItinerary?.tour.noOfDays, lang: this.singleItinerary?.tour.language})">
                  <span nz-icon nzType="plus"></span>
                  {{!this.isAiContentPresent ? ('itineraries.addEditItinerary.overview.quickGenerate' | transloco) :  ('itineraries.addEditItinerary.itinerarySection.regenerate' | transloco)}}
                </button>
              </div>
<!--              <nz-form-item>-->
<!--                <nz-form-control [nzErrorTip]="descriptionCheck">-->
<!--                  <textarea-->
<!--                    placeholder="Add description for the entire itinerary"-->
<!--                    nz-input-->
<!--                    formControlName="description"-->
<!--                    rows="12"></textarea>-->
<!--                </nz-form-control>-->
<!--                <ng-template #descriptionCheck>-->
<!--                  <span *ngIf="formDestinationErrors.description?.required"-->
<!--                  >Description is required</span-->
<!--                  >-->
<!--                </ng-template>-->
<!--              </nz-form-item>-->
              <quill-editor
                class="w-full h-56"
                [placeholder]="'itineraries.addEditItinerary.overview.addDescriptionForEntireItinerary' | transloco"
                formControlName="description">
                <div quill-editor-toolbar>
                  <div class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                  </div>
                  <!--                      <div class="ql-formats">-->
                  <!--                        <button class="ql-list" value="ordered"></button>-->
                  <!--                        <button class="ql-list" value="bullet"></button>-->
                  <!--                      </div>-->
                </div>
              </quill-editor>

              <div class="mt-3">
                <div
                  *ngIf="this.singleItinerary?.days[0].destination === undefined || this.singleItinerary?.experiences[0]?.experiencesPerDay.length == 0">
                  <nz-alert nzType="info" nzShowIcon
                            [nzMessage]="'itineraries.addEditItinerary.overview.moreInformationNeeded' | transloco"></nz-alert>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </nz-card>
  </nz-spin>
  <nz-spin [nzSpinning]="cardLoading">
    <nz-card class="my-8" id="inclusions-section">
      <form nz-form [formGroup]="itineraryForm">
        <div class="grid md:grid-cols-2 gap-6 my-4">
          <div>
            <div class="flex flex-row items-center justify-between gap-5">
              <h5>{{ 'otherContent.tabs.inclusions' | transloco }}</h5>
              <button nz-button *ngIf="this.singleItinerary?.tour.language !== 'en'"
              class="ai-button flex items-center" nz-button nzType="default"
              [disabled]="!itineraryForm.value.inclusions"
              (click)="translateContent(
              itineraryForm.value.inclusions,
              this.singleItinerary?.tour.language,
              'inclusions')">
              <span nz-icon nzType="plus"></span>
              {{ 'itineraries.addEditItinerary.actions.translate' | transloco }}
              </button>
            </div>
            <nz-divider></nz-divider>
            <quill-editor
              class="w-full h-96"
              formControlName="inclusions"
              [placeholder]="'otherContent.placeholders.inclusions' | transloco">
              <div quill-editor-toolbar>
                <div class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                </div>
                <div class="ql-formats">
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                </div>
              </div>
            </quill-editor>
          </div>
          <div>
            <div class="flex flex-row items-center justify-between gap-5">
              <h5>{{ 'otherContent.tabs.exclusions' | transloco }}</h5>
              <button nz-button *ngIf="this.singleItinerary?.tour.language !== 'en'"
              [disabled]="!itineraryForm.value.exclusions"
              (click)="translateContent(
              itineraryForm.value.exclusions,
              this.singleItinerary?.tour.language,
              'exclusions')"
               class="ai-button flex items-center" nz-button nzType="default">
              <span nz-icon nzType="plus"></span>
              {{ 'itineraries.addEditItinerary.actions.translate' | transloco }}
              </button>
            </div>
            <nz-divider></nz-divider>
            <quill-editor
              class="w-full h-96"
              formControlName="exclusions"
              [placeholder]="'otherContent.placeholders.exclusions' | transloco">
              <div quill-editor-toolbar>
                <div class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                </div>
                <div class="ql-formats">
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                </div>
              </div>
            </quill-editor>
          </div>
          <div>
            <div class="flex flex-row items-center justify-between gap-5">
              <h5>{{ 'otherContent.tabs.termsAndConditions' | transloco }}</h5>
              <button nz-button *ngIf="this.singleItinerary?.tour.language !== 'en'"
              [disabled]="!itineraryForm.value.policies"
              (click)="translateContent(
              itineraryForm.value.policies,
              this.singleItinerary?.tour.language,
              'policies')"
               class="ai-button flex items-center" nz-button nzType="default">
              <span nz-icon nzType="plus"></span>
              {{ 'itineraries.addEditItinerary.actions.translate' | transloco }}
              </button>
            </div>
            <nz-divider></nz-divider>
            <quill-editor
              class="w-full h-96"
              formControlName="policies"
              [placeholder]="'otherContent.placeholders.policies' | transloco">
              <div quill-editor-toolbar>
                <div class="ql-formats">
                  <button class="ql-bold"></button>
                  <button class="ql-italic"></button>
                </div>
                <div class="ql-formats">
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                </div>
              </div>
            </quill-editor>
          </div>
        </div>
      </form>
      <div class="grid md:grid-cols-2 gap-6 my-4">
        <form nz-form [formGroup]="additionalNotesForm">
          <div id="additional-notes-section">
            <div class="flex flex-row items-center gap-5">
              <h5>
                {{ additionalNotesForm.value.title || ('itineraries.addEditItinerary.additionalNotes.defaultTitle' | transloco) }}
              </h5>
              <div
                *ngIf="this.singleItinerary?.lock !== null && !this.determineStatusLogic()"
                (click)="onOpenAdditionalNotesTitleModal(additionalNotesForm.value.title, this.singleItinerary.tour.language)"
                class="cursor-pointer"
              >
                 <lucide-icon name="square-pen" class="flex remarksTitle-url-icon cursor-pointer"></lucide-icon>
              </div>
            </div>
            <nz-divider></nz-divider>
            <app-additional-notes-rich-text-editor
              class="w-full"
              formControlName="content"
              [placeholder]="'itineraries.addEditItinerary.additionalNotes.placeholder' | transloco">
            </app-additional-notes-rich-text-editor>
          </div>
        </form>
        <div>
            <div class="mb-[0.2rem]">
              <h5>{{ 'itineraries.addEditItinerary.previewExportOptions.title' | transloco }}</h5>
              <span class="text-sm">
                {{ 'itineraries.addEditItinerary.previewExportOptions.description' | transloco }}
              </span>
            </div>
            <nz-divider class="mt-0"></nz-divider>
            <div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.accommodationHotel' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="hotelRatingBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideHotelStarRatings' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.accommodationNoteBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideNotes' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="hotelDescriptionBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideDescription' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="hotelWebsiteBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideWebsiteLink' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="hotelImageBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideHotelImage' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="accommodationRoomsBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideRooms' | transloco }}</label>
                </div>
              </div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.transport' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="mileageBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideMileage' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.transportNoteBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideNotes' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="travelTimeBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideTravelTime' | transloco }}</label>
                </div>

                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="vehicleNameBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideVehicleName' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="vehicleImageBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideVehicleImage' | transloco }}</label>
                </div>
              </div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.experience' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.experiencesNoteBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideNotes' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.includeBadgeBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideIncludedBadge' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.excludeBadgeBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideExcludedBadge' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.hideExperiencesTimesBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideExperiencesTimes' | transloco }}</label>
                </div>
              </div>
<!--                  TODO DONT REMOVE THIS CODE, I MIGHT NEED IT IN THE FUTURE-->
<!--              <nz-divider nzText="Company" nzOrientation="left"></nz-divider>-->
<!--              <div class="grid grid-cols-2">-->
<!--                <div>-->
<!--                  <label-->
<!--                    class="mb-1"-->
<!--                    nz-checkbox-->
<!--                    [ngModelOptions]="{standalone: true}"-->
<!--                    [(ngModel)]="companyInformationBoxChecked"-->
<!--                  >Hide Company Information</label>-->
<!--                </div>-->
<!--                <div *ngIf="this.singleItinerary?.tour?.type !== 'B2B'">-->
<!--                  <label-->
<!--                    class="mb-1"-->
<!--                    nz-checkbox-->
<!--                    [ngModelOptions]="{standalone: true}"-->
<!--                    [(ngModel)]="tourOperatorBoxChecked"-->
<!--                  >Hide Tour Operator</label>-->
<!--                </div>-->
<!--              </div>-->

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.customer' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="customerInformationBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideCustomerInformation' | transloco }}</label>
                </div>
              </div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.costing' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="costingBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideCosting' | transloco }}</label>
                </div>

                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="this.pricingRemarksBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideSpecialNotes' | transloco }}</label>
                </div>
              </div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.mapOptions' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <nz-radio-group [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()" [ngModelOptions]="{standalone: true}" [(ngModel)]="this.mapType">
                    <label *ngFor="let map of mapTypeOptions"  nz-radio [nzValue]="map.value">{{map.label}}</label>
                  </nz-radio-group>
                </div>
              </div>

              <nz-divider [nzText]="'itineraries.addEditItinerary.previewExportOptions.sections.general' | transloco" nzOrientation="left"></nz-divider>
              <div class="grid grid-cols-2">
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="itineraryReferenceNumberBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideItineraryReferenceNumber' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="itineraryTitleBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideItineraryTitle' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="remarksTipsBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideDayFeaturedTipsRemarks' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="additionalNotesBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideTourWiseAdditionalNotes' | transloco }}</label>
                </div>
                <div *ngIf="this.singleItinerary?.tour?.type !== 'B2B'">
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="paymentLinkBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hidePaymentLink' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="websiteLinkBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideWebsiteLink' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="displayMapTopsideBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.displayMapOnTop' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="thumbnailBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideDayThumbnails' | transloco }}</label>
                </div>
                <div>
                  <label
                    class="mb-1"
                    nz-checkbox
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="hideDaywiseInclusionsExclusionsBoxChecked"
                    [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
                  >{{ 'itineraries.addEditItinerary.previewExportOptions.options.hideDaywiseInclusionsExclusions' | transloco }}</label>
                </div>
              </div>
            </div>
            <div class="mt-10">
              <nz-alert nzType="warning"
                        [nzMessage]="'itineraries.addEditItinerary.previewExportOptions.warning' | transloco"
                        nzShowIcon>
              </nz-alert>
            </div>
          </div>
        </div>
          <div *ngIf="this.singleItinerary?.tour?.type !== 'B2B'">
            <h5>{{ 'itineraries.addEditItinerary.paymentLink.title' | transloco }}</h5>
            <nz-divider></nz-divider>
            <textarea
              nz-input
              [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
              [placeholder]="'itineraries.addEditItinerary.paymentLink.placeholder' | transloco"
              [(ngModel)]="this.paymentLink"
              [value]="this.paymentLink"
              (ngModelChange)="this.paymentLinkOnChange($event)"
              [ngModelOptions]="{standalone: true}"
              rows="3">
            </textarea>
            <div class="mt-2" *ngIf="!this.isValidUrl">
              <nz-alert nzType="error"
                        [nzMessage]="'itineraries.addEditItinerary.paymentLink.invalidLink' | transloco"
                        nzShowIcon>
              </nz-alert>
            </div>
          </div>
          <div>
            <h5>{{ 'itineraries.addEditItinerary.remarks.title' | transloco }}</h5>
            <nz-divider></nz-divider>
            <textarea
              nz-input
              [disabled]="this.singleItinerary?.lock === null || this.determineStatusLogic()"
              [placeholder]="'itineraries.addEditItinerary.remarks.placeholder' | transloco"
              [(ngModel)]="this.remarks"
              [value]="this.remarks"
              (ngModelChange)="remarksItineraryOnChange($event)"
              [ngModelOptions]="{standalone: true}" rows="3">
            </textarea>
          </div>
    </nz-card>
  </nz-spin>
</div>

<nz-modal
  [nzVisible]="previewVisible"
  [nzContent]="modalContent"
  [nzFooter]="null"
  (nzOnCancel)="previewVisible = false">
  <ng-template #modalContent>
    <img
      [src]="previewImage ? previewImage : placeholderPath"
      [ngStyle]="{ width: '100%' }" />
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="sendEmailIsVisible"
  [nzTitle]="this.modalTitle"
  (nzOnCancel)="sendEmailCancel('emailModal')">
  <ng-container *nzModalContent>
    <div>
      <form nz-form [formGroup]="emailForm">
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailTo"
          >{{ 'itineraries.addEditItinerary.emailModal.fields.to' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailToCheck">
            <nz-select
              nzMode="tags"
              [nzPlaceHolder]="'itineraries.addEditItinerary.emailModal.placeholders.receiverEmail' | transloco"
              formControlName="sendEmailTo"
              nzPlacement="topLeft"
              (ngModelChange)="setDefaultClientMail($event)">
            </nz-select>
          </nz-form-control>
          <ng-template class="m-0" #emailToCheck>
            <span *ngIf="formErrorsEmail.sendEmailTo.required">
              {{ 'itineraries.addEditItinerary.emailModal.errors.emailRequired' | transloco }}
            </span>
            <span *ngIf="formErrorsEmail.sendEmailTo.email">
              {{ 'itineraries.addEditItinerary.emailModal.errors.emailInvalid' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailCc"
          >{{ 'itineraries.addEditItinerary.emailModal.fields.cc' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailCcCheck">
            <nz-input-group>
              <nz-select
                nzMode="tags"
                [nzPlaceHolder]="'itineraries.addEditItinerary.emailModal.placeholders.receiverEmail' | transloco"
                formControlName="sendEmailCc"
                nzPlacement="topLeft">
              </nz-select>
            </nz-input-group>
          </nz-form-control>
          <ng-template #emailCcCheck>
            <span *ngIf="formErrorsEmail.sendEmailCc.email"> {{ 'itineraries.addEditItinerary.emailModal.errors.emailInvalid' | transloco }} </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailSubject"
          >{{ 'itineraries.addEditItinerary.emailModal.fields.subject' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="subjectCheck">
            <nz-input-group>
              <input
                class="custom-email-sub-radius"
                nz-input
                type="text"
                [placeholder]="'itineraries.addEditItinerary.emailModal.placeholders.emailSubject' | transloco"
                formControlName="sendEmailSubject"/>
            </nz-input-group>
          </nz-form-control>
          <ng-template #subjectCheck>
            <span *ngIf="formErrorsEmail.sendEmailSubject.required">
              {{ 'itineraries.addEditItinerary.emailModal.errors.subjectRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
      </form>
    </div>
    <div *ngIf="this.sendInfo.type === 'Itinerary'" class="mt-3">
      <label
        nz-checkbox
        [(ngModel)]="this.attachWithPDFChecked"
        [ngModelOptions]="{standalone: true}"
      >{{ 'itineraries.addEditItinerary.emailModal.attachPdfItinerary' | transloco }}</label>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="sendEmailCancel('emailModal')">
      {{ 'itineraries.common.cancel' | transloco }}
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="emailForm.invalid"
      (click)="sendEmailConfirmModal()">
      {{ 'itineraries.common.send' | transloco }}
    </button>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="sendEmailConfirmIsVisible"
  [nzTitle]="this.modalTitleConfirmBox"
  (nzOnCancel)="sendEmailCancel('confirmModal')">
  <ng-container *nzModalContent>
    <div>
      <p>
        <span *ngIf="sendInfo.type === 'Itinerary'"
        >{{ 'itineraries.addEditItinerary.confirmModal.sendItinerary' | transloco }}
        </span>
        <span *ngIf="sendInfo.type === 'Invoice'"
        >{{ 'itineraries.addEditItinerary.confirmModal.sendInvoice' | transloco }}
        </span>
      </p>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="sendEmailCancel('confirmModal')">
      {{ 'itineraries.common.cancel' | transloco }}
    </button>
    <button nz-button nzType="primary" (click)="SendEmail()">{{ 'itineraries.common.confirm' | transloco }}</button>
  </div>
</nz-modal>


<nz-modal
  [(nzVisible)]="seasonPricingIsVisible"
  [nzTitle]="'itineraries.addEditItinerary.seasonalPricing.columnConfig' | transloco"
  (nzOnCancel)="seasonalPricingCancel()">
  <ng-container *nzModalContent>
    <div>
        <nz-form-item class="mb-1">
          <nz-form-label nzFor="columName"
          >{{ 'itineraries.addEditItinerary.seasonalPricing.columnName' | transloco }}
          </nz-form-label>
          <nz-form-control>
              <input
                nz-input
                type="text"
                [placeholder]="'itineraries.addEditItinerary.seasonalPricing.enterColumnName' | transloco"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="this.seasonPricingColName"/>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="this.headerIndex !== 0">
          <nz-form-control>
            <label
              nz-checkbox
              [(ngModel)]="this.isCostColumn"
              [ngModelOptions]="{standalone: true}"
            >{{ 'itineraries.addEditItinerary.seasonalPricing.costColumn' | transloco }}</label>
          </nz-form-control>
        </nz-form-item>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="seasonalPricingCancel()">
      {{ 'itineraries.common.cancel' | transloco }}
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="this.seasonPricingColName === ''"
      (click)="seasonalPricingConfirmModal()">
      {{this.seasonPricingType === 'new'
        ? ('itineraries.addEditItinerary.seasonalPricing.newColumn' | transloco)
        : ('itineraries.addEditItinerary.seasonalPricing.editColumn' | transloco)}}
    </button>
  </div>
</nz-modal>
